import React, { lazy, useEffect, useMemo, useState, useCallback } from "react";

import {
  MaterialReactTable,
  type MRT_ColumnDef,
  useMaterialReactTable,
  MRT_Cell,
} from "material-react-table";
import {
  Box,
  IconButton,
  Tooltip,
  CircularProgress,
  Tabs,
  Tab,
  Chip,
  Button,
} from "@mui/material";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import Accordion from "react-bootstrap/Accordion";
import { Container, Row } from "reactstrap";
import MenuItem from "@mui/material/MenuItem";
import axiosInstance from "../../../Utils/axiosInstance";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import CloseIcon from "@mui/icons-material/Close";
import dayjs from "dayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import GetAppIcon from "@mui/icons-material/GetApp";
import FilterField, { FilterAutocomplete } from "../Filters/FilterField";
import { fetchclearingAccountOptions, fetchCustomerAccountOptions } from "../PaperTrading/FecthApis";
import ActionButton from "../../../Components/Buttons/DefaultStyle/ActionButton";

const KBBL = "kbbl";
const LOTS = "lots";
const LOTS_STATEMENT = "lots-statement";
const STRATEGY = "strategy";
const CLEARER = "clearer";
const BOOK = "book";
const TRADE_TYPE = "trade_type";
const FUTURES = "futures"
const SWAPS = "swaps"
const CONTRACT = "contract";
const CONTRACT_MONTH = "contractMonth";
const DERIVATIVE = "derivatives";
const CONTRACT_NAME = "contract_name";
const CLEARING_ACCOUNT = "clearing_account";
const ACCOUNT = "account";
const CUST_BOOK = "cust_book";
const TILL_DATE = "till_date";
const OBJECT = "object";
const QUANTITY = "quantity";
const BUY_SELL = "buy_sell";
const BUY = "buy";
const SELL = "sell";
const CLEARED = "cleared";
const CLEAREDLABEL = "Cleared";
const BILATERAL = "bilateral";
const BILATERALLABEL = "Bilateral";
const INTERNAL = "internal";
const INTERNALLABEL = "Internal";


// Define the API response type
type ApiResponseItem = {
  contractMonth: string;
  derivative: string;
  headerName: string;
  position: string | number;
};

type User = {
  contractMonth: string;

  Total_kbbl: number;
  [key: string]: string | number;
};

type UnitLabel = { value: string; label: string } | null;
type Book = {
  id: string | number;
  name: string;
  // Add other fields if the API returns more data
};

type SelectOption = {
  value: string;
  label: string;
};
type SelectedTradeType = {
  values: string[];
  isAll: boolean;
  isPartialAll: boolean;
};

const FILTER_WIDTH = {
  minWidth: 160,
  maxWidth: 160,
  flex: "0 0 160px",
};
const Example = () => {
  const [selectedUnit, setSelectedUnit] = useState<string>("40");
  const [selectedBook, setSelectedBook] = useState<string>("");
  const [selectedClearer, setSelectedClearer] = useState<string>("");
  const [selectedStrategy, setSelectedStrategy] = useState<string>("");
  const [selectedTradeType, setSelectedTradeType] = useState<SelectedTradeType>({
    values: [],
    isAll: false,
    isPartialAll: false,
  });
  const [selectedClearingAccount, setSelectedClearingAccount] = useState<SelectedTradeType>({
    values: [],
    isAll: false,
    isPartialAll: false,
  });
  const [selectedCustomerAccount, setSelectedCustomerAccount] = useState<SelectedTradeType>({
    values: [],
    isAll: false,
    isPartialAll: false,
  });
  const [tempSelectedCustomerAccount, setTempSelectedCustomerAccount] = useState<SelectedTradeType>(selectedCustomerAccount);
  const [customerAccountOptions, setCustomerAccountOptions] = useState<SelectOption[]>([]);
  const [isLoadingCustomerAccounts, setIsLoadingCustomerAccounts] = useState<boolean>(false);
  const [selectedCustBook, setSelectedCustBook] = useState<string>("");
  const [isLoadingCustBooks, setIsLoadingCustBooks] = useState<boolean>(false);
  const [validationErrors, setValidationErrors] = useState<
    Record<string, string | undefined>
  >({});
  const [selectedDate, setSelectedDate] = useState<string>("");
  const [tempSelectedDate, setTempSelectedDate] = useState<string>(selectedDate);
  const [tempSelectedBook, setTempSelectedBook] = useState<string>(selectedBook);
  const [tempSelectedClearer, setTempSelectedClearer] = useState<string>(selectedClearer);
  const [tempSelectedStrategy, setTempSelectedStrategy] = useState<string>(selectedStrategy);
  const [tempSelectedTradeType, setTempSelectedTradeType] = useState<SelectedTradeType>(selectedTradeType);
  const [tempSelectedClearingAccount, setTempSelectedClearingAccount] = useState<SelectedTradeType>(selectedClearingAccount);
  const [tempSelectedCustBook, setTempSelectedCustBook] = useState<string>(selectedCustBook);

  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [tableData, setTableData] = useState<User[]>([]);
  const [secondTableData, setSecondTableData] = useState<any[]>([]);
  const [thirdTableData, setThirdTableData] = useState<any[]>([]);
  const [forthTableData, setForthTableData] = useState<any[]>([]);

  const [isLoadingSecond, setIsLoadingSecond] = useState<boolean>(true);
  // Store the original API data to preserve derivative information
  const [originalApiData, setOriginalApiData] = useState<ApiResponseItem[]>([]);

  // New state for second table filters
  const [selectedContractMonth, setSelectedContractMonth] =
    useState<string>("");
  const [selectedDerivative, setSelectedDerivative] = useState<string>("");
  const [selectedContractName, setSelectedContractName] = useState<string>("");
  // Add state for error message
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [totalUnitLabel, setTotalUnitLabel] = useState<UnitLabel>(null);
  const [bookOptions, setBookOptions] = useState<SelectOption[]>([
    { value: "", label: "" },
    { value: "10", label: "All Book" },
  ]);
  const [isLoadingBooks, setIsLoadingBooks] = useState<boolean>(false);
  // FIXED: Create a safe key for object properties while preserving original headerName

  const [showSecondTable, setShowSecondTable] = useState<boolean>(false);
  const [showThirdTable, setShowThirdTable] = useState<boolean>(false);

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [showFilter, setShowFilter] = useState(false);

  // Add new state for fourth table filters to avoid conflicts
  const [fourthTableContractMonth, setFourthTableContractMonth] =
    useState<string>("");
  const [fourthTableDerivative, setFourthTableDerivative] =
    useState<string>("");
  const [fourthTableContractName, setFourthTableContractName] =
    useState<string>("");
  const [fourthTableData, setFourthTableData] = useState<any[]>([]);
  const [showFourthTable, setFourthTable] = useState<boolean>(false);

  const [clearerOptions, setClearerOptions] = useState<SelectOption[]>([
    { value: "", label: "" },
  ]);
  const [strategyOptions, setStrategyOptions] = useState<SelectOption[]>([
    { value: "", label: "" },
  ]);
  const [tradeTypeOptions, setTradeTypeOptions] = useState<SelectOption[]>([
    { value: "", label: "" },
  ]);
  const [clearingAccountOptions, setClearingAccountOptions] = useState<SelectOption[]>([
    { value: "", label: "" },
  ])
  const [custBookOptions, setCustBookOptions] = useState<SelectOption[]>([
    { value: "", label: "" },
  ]);
  const [activeTab, setActiveTab] = useState(0); // 0 = Tab1, 1 = Tab2
  const [customerError, setCustomerError] = useState(false);

  const [isLoadingClearers, setIsLoadingClearers] = useState<boolean>(false);
  const [isLoadingStrategies, setIsLoadingStrategies] =
    useState<boolean>(false);

  const [columnOrder, setColumnOrder] = useState<string[]>([]);

  const createSafeKey = (headerName: string) => {
    // Create a safe key for object property access
    return `header_${btoa(encodeURIComponent(headerName)).replace(
      /[^a-zA-Z0-9]/g,
      "_"
    )}`;
  };

  const traderTypeOptions = [
    { label: CLEAREDLABEL, value: CLEARED },
    { label: BILATERALLABEL, value: BILATERAL },
    { label: INTERNALLABEL, value: INTERNAL },
  ];

  const unitOptions = [
    { label: KBBL, value: "10" },
    { label: LOTS, value: "30" },
    { label: LOTS_STATEMENT, value: "40" },
  ];

  // Create a mapping between safe keys and original header names
  const [headerMapping, setHeaderMapping] = useState<Map<string, string>>(
    new Map()
  );

  const loadClearingAccountOptions = async () => {
    const { data, error } = await fetchclearingAccountOptions();

    if (data && !error) {
      const options: SelectOption[] = data.map((item: any) => ({
        value: item.name,
        label: item.label,
      }));

      setClearingAccountOptions([
        ...options
      ]);
    } else {
      console.error("Error fetching clearing accounts:", error);
    }
  };

  const loadCustomerAccountOptions = async (customerName: string) => {
    if (!customerName) {
      setCustomerAccountOptions([]);
      return;
    }
    setIsLoadingCustomerAccounts(true);
    const { data, error } = await fetchCustomerAccountOptions(customerName);
    if (data && !error) {
      const accounts = data.accounts ?? [];
      const options: SelectOption[] = accounts.map((item: any) => ({
        value: String(item.account_number ?? item.value ?? item.id ?? item),
        label: String(item.account_number ?? item.label ?? item.name ?? item),
      }));
      setCustomerAccountOptions(options);
    } else {
      console.error("Error fetching customer accounts:", error);
      setCustomerAccountOptions([]);
    }
    setIsLoadingCustomerAccounts(false);
  };

  useEffect(() => {
    if (activeTab === 0) {
      // Tab 1 → always default "40"
      setSelectedUnit("40");
    } else if (activeTab === 1) {
      // Tab 2 → blank
      setSelectedUnit("30");
    }
  }, [activeTab]);

  useEffect(() => {
    if (activeTab === 1) {
      setCustomerError(!tempSelectedCustBook);
      return;
    }
    setCustomerError(false);
  }, [activeTab, tempSelectedCustBook]);

  useEffect(() => {
    if (activeTab !== 1) return;

    // Reset account selections when customer changes
    setTempSelectedCustomerAccount({ values: [], isAll: false, isPartialAll: false });
    setSelectedCustomerAccount({ values: [], isAll: false, isPartialAll: false });
    setCustomerAccountOptions([]);

    // Only fetch if customer is selected
    if (tempSelectedCustBook) {
      loadCustomerAccountOptions(tempSelectedCustBook);
    }
  }, [tempSelectedCustBook]);

  useEffect(() => {
    setColumnOrder([]);
  }, [activeTab, selectedUnit, selectedCustBook]);
  
  // Helper function to safely parse numbers
  const safeParseFloat = (value: any): number => {
    if (value === null || value === undefined || value === "") {
      return 0;
    }
    const parsed = parseFloat(String(value));
    return isNaN(parsed) ? 0 : parsed;
  };

  // FIXED: Helper function to group data and create dynamic structure
  const createDynamicTableData = (data: ApiResponseItem[]) => {
    // Ensure data is an array
    if (!Array.isArray(data)) {
      console.warn("API response is not an array:", data);
      return [];
    }

    if (data.length === 0) return [];

    // Create header mapping for safe keys
    const newHeaderMapping = new Map<string, string>();

    // Group by contractMonth to create rows
    const groupedByMonth = data.reduce((acc, item) => {
      if (!acc[item.contractMonth]) {
        acc[item.contractMonth] = {
          contractMonth: item.contractMonth || "",
        };
      }

      // Create safe key and store mapping
      const safeKey = createSafeKey(item.headerName);
      newHeaderMapping.set(safeKey, item.headerName);

      // ✅ Preserve non-numeric values
      const positionValue =
        !isNaN(parseFloat(String(item.position))) && isFinite(+item.position)
          ? String(item.position) // numeric string
          : String(item.position); // non-numeric string

      acc[item.contractMonth][safeKey] = positionValue;

      return acc;
    }, {} as Record<string, any>);

    // Update header mapping state
    setHeaderMapping(newHeaderMapping);

    // Calculate Total_kbbl for each row (sum only numeric values)
    const tableData = Object.values(groupedByMonth).map((row: any) => {
      const total = Object.keys(row)
        .filter((key) => key !== CONTRACT_MONTH)
        .reduce((sum, key) => {
          const value = row[key];
          const numValue =
            !isNaN(parseFloat(value)) && isFinite(+value)
              ? parseFloat(value)
              : 0;
          return sum + numValue;
        }, 0);

      return {
        ...row,
        Total_kbbl: total,
      };
    });

    return tableData;
  };

  const unitMap: Record<string, string> = {
    "40": LOTS_STATEMENT,
    "30": LOTS,
    "10": KBBL,
  };
  // Function to get unique headers from data with their derivative types
  const getUniqueHeadersWithDerivatives = (data: ApiResponseItem[]) => {
    // Ensure data is an array
    if (!Array.isArray(data)) {
      return [];
    }

    const headerMap = new Map<string, string>();
    data.forEach((item) => {
      if (item && item.headerName && item.derivative) {
        headerMap.set(item.headerName, item.derivative);
      }
    });

    return Array.from(headerMap.entries()).map(([headerName, derivative]) => ({
      headerName,
      derivative,
    }));
  };

  const fetchDataClearers = async () => {
    try {
      setIsLoadingClearers(true);
      const response = await axiosInstance.get("/paper-app/clearers/");
      let apiData = response.data;

      let clearers: any[] = [];
      if (Array.isArray(apiData)) {
        clearers = apiData;
      } else if (apiData?.results && Array.isArray(apiData.results)) {
        clearers = apiData.results;
      }

      const options: SelectOption[] = [
        { value: "", label: "" },
        ...clearers.map((clr) => ({
          value: String(clr.name || clr.id),
          label: clr.name || clr.id,
        })),
      ];
      setClearerOptions(options);
    } catch (error) {
      console.error("Error fetching clearers:", error);
    } finally {
      setIsLoadingClearers(false);
    }
  };

  const fetchDataStrategies = async () => {
    try {
      setIsLoadingStrategies(true);
      const response = await axiosInstance.get("/paper-app/strategies/");
      let apiData = response.data;

      let strategies: any[] = [];
      if (Array.isArray(apiData)) {
        strategies = apiData;
      } else if (apiData?.results && Array.isArray(apiData.results)) {
        strategies = apiData.results;
      }

      const options: SelectOption[] = [
        { value: "", label: "" },
        ...strategies.map((st) => ({
          value: String(st.name),
          label: st.name || st.id,
        })),
      ];
      setStrategyOptions(options);
    } catch (error) {
      console.error("Error fetching strategies:", error);
    } finally {
      setIsLoadingStrategies(false);
    }
  };

  const fetchDataCustBooks = async () => {
    try {
      setIsLoadingCustBooks(true);
      const response = await axiosInstance.get(
        "/paper-app/paper-trading-customer-companies-unique/"
      );
      const apiData = response.data;

      let companies: any[] = [];
      if (Array.isArray(apiData)) {
        companies = apiData;
      } else if (apiData?.results && Array.isArray(apiData.results)) {
        companies = apiData.results;
      }

      const options: SelectOption[] = [
        { value: "", label: "" }, // empty option
        ...companies.map((c) => ({
          value: c.customer_company_name, // ✅ only customer_company_name
          label: c.customer_company_name,
        })),
      ];

      setCustBookOptions(options);
    } catch (error) {
      console.error("Error fetching customer companies:", error);
    } finally {
      setIsLoadingCustBooks(false);
    }
  };

  // Function to categorize headers based on derivative field
  const categorizeHeaders = (
    headersWithDerivatives: Array<{ headerName: string; derivative: string }>
  ) => {
    const futures = headersWithDerivatives
      .filter(
        (item) => item.derivative && item.derivative.toLowerCase() === FUTURES
      )
      .map((item) => item.headerName);

    const swaps = headersWithDerivatives
      .filter(
        (item) => item.derivative && item.derivative.toLowerCase() === SWAPS
      )
      .map((item) => item.headerName);

    return { futures, swaps };
  };

  // FIXED: Calculate total for a specific column using safe key
  const calculateTotal = (data: User[], safeKey: string) => {
    return data.reduce((acc, row) => {
      const value = row[safeKey];
      const num = safeParseFloat(value);
      return acc + num;
    }, 0);
  };

  // Utility function to format date from DD-MMM-YY to DD-MMM-YYYY
  const formatDateToFullYear = (dateStr: string): string => {
    if (!dateStr) return dateStr;
    const parts = dateStr.split("-");
    if (parts.length !== 3) return dateStr; // Return original if format is unexpected
    const [day, month, year] = parts;
    const fullYear = year.length === 2 ? `20${year}` : year; // Convert YY to YYYY
    return `${day}-${month}-${fullYear}`;
  };

  // FIXED: Modified handleCellClick to work with safe keys
  const handleCellClick = (cell: MRT_Cell<User>) => {
    const row = cell.row.original;
    const safeColumnKey = cell.column.id;
    const cellValue = cell.getValue();

    // Skip if clicking on contractMonth column or if value is not a number
    if (safeColumnKey === CONTRACT_MONTH || isNaN(safeParseFloat(cellValue))) {
      return;
    }

    // Get original header name from mapping
    const originalHeaderName = headerMapping.get(safeColumnKey);
    if (!originalHeaderName) {
      console.warn(`No header mapping found for key: ${safeColumnKey}`);
      return;
    }

    const contractMonth = row.contractMonth;
    const formattedContractMonth = formatDateToFullYear(contractMonth);

    // Find the derivative type from original API data
    const apiItem = originalApiData.find(
      (item) =>
        item.headerName === originalHeaderName &&
        item.contractMonth === contractMonth
    );

    const derivative = apiItem
      ? apiItem.derivative.toLowerCase()
      : originalHeaderName.toLowerCase().includes(FUTURES)
        ? FUTURES
        : SWAPS;

    // Set filter parameters for second table
    setSelectedContractMonth(formattedContractMonth);
    setSelectedDerivative(derivative);
    setSelectedContractName(originalHeaderName);
    setShowSecondTable(true); // Show second table
    setShowThirdTable(false); // Hide third table
    setFourthTable(false); // Hide fourth table
    setForthTableData([]); // Clear fourth table data
  };

  // Update useEffect for second table data to prevent fetching when fourth table is active
  useEffect(() => {
    // Only fetch second table data when all required filters are present and fourth table is not active
    if (
      selectedContractMonth &&
      selectedDerivative &&
      selectedContractName &&
      !showFourthTable // Prevent fetching when fourth table is active
    ) {
      fetchSecondTableData();
    }
  }, [
    selectedContractMonth,
    selectedDerivative,
    selectedContractName,
    showFourthTable,
  ]);

  const fetchTableData = async (
    date_str: string,
    derivatives: string,
    contractName: string,
    fqMode = false
  ) => {
    try {
      setLoading(true);
      setError(null);

      const params = new URLSearchParams();
      if (date_str) params.append("date_str", date_str);
      if (derivatives) params.append(DERIVATIVE, derivatives);
      if (contractName) params.append(CONTRACT_NAME, contractName);
      if (selectedBook) params.append(BOOK, selectedBook);
      if (selectedUnit) params.append("trade_unit", unitMap[selectedUnit]);
      if (selectedClearer) params.append(CLEARER, selectedClearer);
      if (selectedStrategy) params.append(STRATEGY, selectedStrategy);
      if (selectedTradeType.values && selectedTradeType.values.length > 0) {
        params.append(TRADE_TYPE, selectedTradeType.values.join(","));
      }
      if (selectedClearingAccount.values && selectedClearingAccount.values.length > 0) {
        params.append(CLEARING_ACCOUNT, selectedClearingAccount.values.join(","));
      }

      if (selectedCustBook) params.append(CUST_BOOK, selectedCustBook);
      if (selectedDate) params.append(TILL_DATE, selectedDate);
      const baseUrl = fqMode
        ? "/paper-app/fq-grouping/"
        : "/paper-app/grouping-summary/";

      const url = `${baseUrl}?${params.toString()}`;
      const response = await axiosInstance.get(url);

      setForthTableData(response.data);
      setFourthTable(true);
      setLoading(false);
    } catch (error: any) {
      setError(error.message || "Failed to fetch data");
      setForthTableData([]);
      setLoading(false);
    }
  };

  // useEffect to fetch data on component mount
  // useEffect(() => {
  //   const fetchData = async () => {
  //     // Define the required variables before using them
  //     const date_str = selectedDate || "";
  //     const derivatives = selectedDerivative || "";
  //     const contract_name = selectedContractName || "";

  //     // Call the fetch function
  //     await fetchTableData(date_str, derivatives, contract_name);
  //   };

  //   fetchData();
  // }, []); // Empty dependency array to run once on mount

  // Button click handler
  const handleButtonClick = async (cell: MRT_Cell<User>, fqMode = false) => {
    const row = cell.row.original;
    const safeColumnKey = cell.column.id;
    const cellValue = cell.getValue();

    // Skip if clicking on contractMonth column or if value is not a number
    if (safeColumnKey === CONTRACT_MONTH || isNaN(safeParseFloat(cellValue))) {
      return;
    }

    // Get original header name from mapping
    const originalHeaderName = headerMapping.get(safeColumnKey);
    if (!originalHeaderName) {
      console.warn(`No header mapping found for key: ${safeColumnKey}`);
      return;
    }

    // Get contractMonth and format it
    const contractMonth = row.contractMonth;
    const formattedContractMonth = contractMonth
      ? formatDateToFullYear(contractMonth)
      : selectedDate || "";

    // Find the derivative type from originalApiData
    const apiItem = originalApiData.find(
      (item) =>
        item.headerName === originalHeaderName &&
        (!contractMonth || item.contractMonth === contractMonth)
    );

    const derivative = apiItem
      ? apiItem.derivative?.toLowerCase()
      : originalHeaderName.toLowerCase().includes(FUTURES)
        ? FUTURES
        : SWAPS;

    // Only proceed if derivative is "swaps"
    if (selectedUnit === "10" && derivative === FUTURES) {
      // OK → proceed
    } else if (derivative !== SWAPS) {
      // For everything else still block
      return;
    }

    // Set filter parameters for fourth table only
    setFourthTableContractMonth(formattedContractMonth);
    setFourthTableDerivative(derivative);
    setFourthTableContractName(originalHeaderName);
    setFourthTable(true); // Show fourth table

    // Explicitly hide second and third tables
    setShowSecondTable(false);
    setShowThirdTable(false); // Hide third table
    setSecondTableData([]);
    setThirdTableData([]); // Clear third table data
    setSelectedContractMonth(""); // Clear second table filters
    setSelectedDerivative("");
    setSelectedContractName("");

    // Fetch fourth table data
    try {
      await fetchTableData(
        formattedContractMonth || selectedDate || "",
        derivative || "",
        originalHeaderName || "",
        fqMode
      );
    } catch (error) {
      console.error("Error fetching table data:", error);
    }
  };

  const fetchDataBook = async () => {
    try {
      setIsLoadingBooks(true);
      const response = await axiosInstance.get("/paper-app/books/");
      const apiData = response.data;

      // Handle different response formats
      let books: Book[] = [];
      if (Array.isArray(apiData)) {
        books = apiData;
      } else if (apiData?.data && Array.isArray(apiData.data)) {
        books = apiData.data;
      } else if (apiData?.results && Array.isArray(apiData.results)) {
        books = apiData.results;
      } else {
        console.warn("Unexpected books API response format:", apiData);
      }

      // Map books to SelectOption format
      const options: SelectOption[] = [
        { value: "", label: "" },
        ...books.map((book) => ({
          value: String(book.name),
          label: book.name,
        })),
      ];

      setBookOptions(options);
    } catch (error) {
      console.error("Error fetching books:", error);
      // Fallback to default options on error
      setBookOptions([
        { value: "", label: "" },
        { value: "10", label: "All Book" },
      ]);
    } finally {
      setIsLoadingBooks(false);
    }
  };

  // New function for kbbl
  const fetchKbblData = async (
    date?: string,
    book?: string,
    clearer?: string,
    strategy?: string,
    trade_type?: string,
    clearing_account?: string,
    account?: string,
    custBook?: string
  ) => {
    try {
      setIsLoading(true);
      let url = "/paper-app/kbbl-position/"; // <-- ✅ new endpoint
      const params = new URLSearchParams();

      if (date) {
        params.append(TILL_DATE, date);
      }
      if (book) {
        params.append(BOOK, book);
      }

      if (clearer) {
        params.append(CLEARER, clearer);
      }
      if (strategy) {
        params.append(STRATEGY, strategy);
      }
      if (trade_type) {
        params.append(TRADE_TYPE, trade_type);
      }
      if (clearing_account) {
        params.append(CLEARING_ACCOUNT, clearing_account);
      }
      if (account) {
        params.append(ACCOUNT, account);
      }
      if (custBook) {
        params.append(CUST_BOOK, custBook);
      }

      if (params.toString()) {
        url += `?${params.toString()}`;
      }

      const response = await axiosInstance.get(url);
      let apiData = response.data;

      // Normalize response like in fetchData
      if (apiData && typeof apiData === OBJECT) {
        if (apiData.data && Array.isArray(apiData.data)) {
          apiData = apiData.data;
        } else if (apiData.results && Array.isArray(apiData.results)) {
          apiData = apiData.results;
        } else if (!Array.isArray(apiData) && typeof apiData === OBJECT) {
          if (apiData.contractMonth || apiData.headerName) {
            apiData = [apiData];
          } else {
            console.warn("Unknown API response format:", apiData);
            apiData = [];
          }
        }
      }
      if (!Array.isArray(apiData)) {
        console.warn("API response is not an array, setting empty data");
        apiData = [];
      }

      setTotalUnitLabel({ value: "10", label: KBBL });
      setSelectedUnit("10");

      // Store original API data
      setOriginalApiData(apiData);

      // Process API data
      const processedData = createDynamicTableData(apiData);
      setTableData(processedData);
    } catch (error) {
      console.error("Error fetching kbbl data:", error);
      setTableData([]);
      setOriginalApiData([]);
      setTotalUnitLabel(null);
      setSelectedUnit(""); // Reset selectedUnit on error
    } finally {
      setIsLoading(false);
    }
  };

  // Fetch book data on component mount
  useEffect(() => {
    fetchData();
    fetchDataBook();
    fetchDataClearers();
    fetchDataStrategies();
    fetchDataCustBooks();
    loadClearingAccountOptions();
    setTradeTypeOptions(traderTypeOptions);
  }, []);

  // Fetch data from API with date parameter
  // Modified fetchData function to include validation
  const fetchData = async (
    date?: string,
    book?: string,
    clearer?: string,
    strategy?: string,
    trade_type?: string,
    clearing_account?: string,
    account?: string,
    custBook?: string
  ) => {
    try {
      setIsLoading(true);
      let url = "/paper-app/lots-per-statement/";
      const params = new URLSearchParams();

      if (date) {
        params.append(TILL_DATE, date);
      }
      if (book) {
        params.append(BOOK, book);
      }
      if (clearer) {
        params.append(CLEARER, clearer);
      }
      if (strategy) {
        params.append(STRATEGY, strategy);
      }
      if (trade_type) {
        params.append(TRADE_TYPE, trade_type);
      }
      if (clearing_account) {
        params.append(CLEARING_ACCOUNT, clearing_account);
      }
      if (account) {
        params.append(ACCOUNT, account);
      }
      if (custBook) {
        params.append(CUST_BOOK, custBook);
      }
      if (params.toString()) {
        url += `?${params.toString()}`;
      }

      const response = await axiosInstance.get(url);

      let apiData = response.data;

      // Handle different response formats
      if (apiData && typeof apiData === OBJECT) {
        if (apiData.data && Array.isArray(apiData.data)) {
          apiData = apiData.data;
        } else if (apiData.results && Array.isArray(apiData.results)) {
          apiData = apiData.results;
        } else if (!Array.isArray(apiData) && typeof apiData === OBJECT) {
          if (apiData.contractMonth || apiData.headerName) {
            apiData = [apiData];
          } else {
            console.warn("Unknown API response format:", apiData);
            apiData = [];
          }
        }
      }
      if (!Array.isArray(apiData)) {
        console.warn("API response is not an array, setting empty data");
        apiData = [];
      }

      // Set unit label when this API is called
      setTotalUnitLabel({ value: "40", label: "lots/statement" });
      // setSelectedUnit("40"); // Ensure selectedUnit matches the API
      // Store original API data
      setOriginalApiData(apiData);

      // Process API data
      const processedData = createDynamicTableData(apiData);

      setTableData(processedData);
    } catch (error) {
      console.error("Error fetching data:", error);
      setTableData([]);
      setOriginalApiData([]);
      setTotalUnitLabel(null);
      setSelectedUnit(""); // Reset selectedUnit on error
    } finally {
      setIsLoading(false);
    }
  };
  // Modified fetchLotsPositionData function to include validation
  const fetchLotsPositionData = async (
    date?: string,
    book?: string,
    clearer?: string,
    strategy?: string,
    trade_type?: string,
    clearing_account?: string,
    account?: string,
    custBook?: string
  ) => {
    try {
      setIsLoading(true);
      let url = "/paper-app/lots-position/";
      const params = new URLSearchParams();

      if (date) {
        params.append(TILL_DATE, date);
      }
      if (book) {
        params.append(BOOK, book);
      }
      if (clearer) {
        params.append(CLEARER, clearer);
      }
      if (strategy) {
        params.append(STRATEGY, strategy);
      }
      if (trade_type) {
        params.append(TRADE_TYPE, trade_type);
      }
      if (clearing_account) {
        params.append(CLEARING_ACCOUNT, clearing_account);
      }
      if (account) {
        params.append(ACCOUNT, account);
      }
      if (custBook) {
        params.append(CUST_BOOK, custBook);
      }
      if (params.toString()) {
        url += `?${params.toString()}`;
      }

      const response = await axiosInstance.get(url);

      let apiData = response.data;

      // Handle different response formats (same as fetchData)
      if (apiData && typeof apiData === OBJECT) {
        if (apiData.data && Array.isArray(apiData.data)) {
          apiData = apiData.data;
        } else if (apiData.results && Array.isArray(apiData.results)) {
          apiData = apiData.results;
        } else if (!Array.isArray(apiData) && typeof apiData === OBJECT) {
          if (apiData.contractMonth || apiData.headerName) {
            apiData = [apiData];
          } else {
            console.warn("Unknown API response format:", apiData);
            apiData = [];
          }
        }
      }
      if (!Array.isArray(apiData)) {
        console.warn("API response is not an array, setting empty data");
        apiData = [];
      }

      // Set unit label for lots
      setTotalUnitLabel({ value: "30", label: LOTS });
      setSelectedUnit("30"); // Ensure selectedUnit matches the API
      // Store original API data
      setOriginalApiData(apiData);

      // Process API data
      const processedData = createDynamicTableData(apiData);
      setTableData(processedData);
    } catch (error) {
      console.error("Error fetching lots position data:", error);
      setTableData([]);
      setOriginalApiData([]);
      setTotalUnitLabel(null);
      setSelectedUnit(""); // Reset selectedUnit on error
    } finally {
      setIsLoading(false);
    }
  };

  const resetSecondTableData = () => {
    setSecondTableData([]);
    setThirdTableData([]);
    setSelectedContractMonth("");
    setSelectedDerivative("");
    setSelectedContractName("");
    setErrorMessage(null);
    setShowSecondTable(false);
    setShowThirdTable(false);
    setFourthTable(false); // Hide fourth table
    setForthTableData([]); // Clear fourth table data
  };
  // Add this useEffect to reset secondTableData when selectedUnit is reset to default
  useEffect(() => {
    if (!selectedUnit) {
      setSecondTableData([]);
      // Optionally clear filter states
      setSelectedContractMonth("");
      setSelectedDerivative("");
      setSelectedContractName("");
    }
  }, [selectedUnit]);
  // Add this function to handle unit selection

  const handleTempDateChange = (value: Date | null) => {
    if (!value) {
      setTempSelectedDate("");
      return;
    }

    const formattedDate = dayjs(value).format("YYYY-MM-DD");
    setTempSelectedDate(formattedDate);

    setValidationErrors((prev) => ({ ...prev, forwardDate: undefined }));
  };


  const handleTempBookChange = (value: string) => {
    setTempSelectedBook(value);
    setValidationErrors((prev) => ({ ...prev, book: undefined }));
  };

  const handleTempClearerChange = (value: string) => {
    setTempSelectedClearer(value);
    setValidationErrors((prev) => ({ ...prev, clearer: undefined }));
  };

  const handleTempStrategyChange = (value: string) => {
    setTempSelectedStrategy(value);
    setValidationErrors((prev) => ({ ...prev, strategy: undefined }));
  };

  const handleTempTradeTypeChange = (
    field: string,
    values: string[],
    isAll?: boolean
  ) => {
    setTempSelectedTradeType({
      values,
      isAll: isAll ?? false,
      isPartialAll: values.length > 0 && values.length < tradeTypeOptions.length,
    });
    setValidationErrors((prev) => ({ ...prev, tradeType: undefined }));
  };

  const handleTempClearingAccountChange = (
    field: string,
    values: string[],
    isAll?: boolean
  ) => {
    setTempSelectedClearingAccount({
      values,
      isAll: isAll ?? false,
      isPartialAll: values.length > 0 && values.length < clearingAccountOptions.length,
    });
    setValidationErrors((prev) => ({ ...prev, clearingAccount: undefined }));
  };

  const handleTempCustomerAccountChange = (
    field: string,
    values: string[],
    isAll?: boolean
  ) => {
    setTempSelectedCustomerAccount({
      values,
      isAll: isAll ?? false,
      isPartialAll: values.length > 0 && values.length < customerAccountOptions.length,
    });
  };

  const handleTempCustBookChange = (value: string) => {
    setTempSelectedCustBook(value);
    setValidationErrors((prev) => ({ ...prev, cust_book: undefined }));
  };

  const handleApplyFilters = async () => {
    if (activeTab === 1 && !tempSelectedCustBook) {
      setCustomerError(true);
      return;
    }
    setCustomerError(false);
    setSelectedDate(tempSelectedDate);
    setSelectedBook(tempSelectedBook);
    setSelectedClearer(tempSelectedClearer);
    setSelectedStrategy(tempSelectedStrategy);
    setSelectedTradeType(tempSelectedTradeType);
    setSelectedClearingAccount(tempSelectedClearingAccount);
    setSelectedCustomerAccount(tempSelectedCustomerAccount);
    setSelectedCustBook(tempSelectedCustBook);

    resetSecondTableData();

    const tradeTypeParam =
      tempSelectedTradeType.values && tempSelectedTradeType.values.length > 0
        ? tempSelectedTradeType.values.join(",")
        : "";

    const clearingAccountParam =
      tempSelectedClearingAccount.values &&
        tempSelectedClearingAccount.values.length > 0
        ? tempSelectedClearingAccount.values.join(",")
        : "";

    const customerAccountParam =
      tempSelectedCustomerAccount.values && tempSelectedCustomerAccount.values.length > 0
        ? tempSelectedCustomerAccount.values.join(",")
        : "";

    try {
      if (selectedUnit === "30") {
        await fetchLotsPositionData(
          tempSelectedDate,
          tempSelectedBook,
          tempSelectedClearer,
          tempSelectedStrategy,
          tradeTypeParam,
          clearingAccountParam,
          customerAccountParam,
          tempSelectedCustBook
        );
      } else if (selectedUnit === "10") {
        await fetchKbblData(
          tempSelectedDate,
          tempSelectedBook,
          tempSelectedClearer,
          tempSelectedStrategy,
          tradeTypeParam,
          clearingAccountParam,
          customerAccountParam,
          tempSelectedCustBook
        );
      } else if (selectedUnit === "40") {
        await fetchData(
          tempSelectedDate,
          tempSelectedBook,
          tempSelectedClearer,
          tempSelectedStrategy,
          tradeTypeParam,
          clearingAccountParam,
          customerAccountParam,
          tempSelectedCustBook
        );
      }
    } catch (error) {
      console.error("Error applying filters:", error);
    }
  };

  const handleClearAllFilters = async () => {
    setSelectedUnit("");

    setTempSelectedDate("");
    setTempSelectedBook("");
    setTempSelectedClearer("");
    setTempSelectedStrategy("");
    setTempSelectedTradeType({
      values: [],
      isAll: false,
      isPartialAll: false,
    });
    setTempSelectedClearingAccount({
      values: [],
      isAll: false,
      isPartialAll: false,
    });
    setTempSelectedCustomerAccount({ values: [], isAll: false, isPartialAll: false });
    setSelectedCustomerAccount({ values: [], isAll: false, isPartialAll: false });
    setTempSelectedCustBook("");

    setSelectedDate("");
    setSelectedBook("");
    setSelectedClearer("");
    setSelectedStrategy("");
    setSelectedTradeType({
      values: [],
      isAll: false,
      isPartialAll: false,
    });
    setSelectedClearingAccount({
      values: [],
      isAll: false,
      isPartialAll: false,
    });
    setSelectedCustBook("");

    setValidationErrors({});
    resetSecondTableData();
    fetchData();
  };

  useEffect(() => {
    setTempSelectedDate(selectedDate);
    setTempSelectedBook(selectedBook);
    setTempSelectedClearer(selectedClearer);
    setTempSelectedStrategy(selectedStrategy);
    setTempSelectedTradeType(selectedTradeType);
    setTempSelectedClearingAccount(selectedClearingAccount);
    setTempSelectedCustBook(selectedCustBook);
    setTempSelectedCustomerAccount(selectedCustomerAccount);
  }, [
    selectedDate,
    selectedBook,
    selectedClearer,
    selectedStrategy,
    selectedTradeType,
    selectedClearingAccount,
    selectedCustBook,
  ]);

  const hasAnyTempFilterValue =
    Boolean(
      tempSelectedDate ||
      tempSelectedBook ||
      tempSelectedClearer ||
      tempSelectedStrategy ||
      tempSelectedCustBook
    ) ||
    (tempSelectedTradeType?.values?.length ?? 0) > 0 ||
    (tempSelectedClearingAccount?.values?.length ?? 0) > 0 ||
    (tempSelectedCustomerAccount?.values?.length ?? 0) > 0;

  const isTab2 = activeTab === 1;
  const isApplyDisabled = isTab2 ? !hasAnyTempFilterValue || !tempSelectedCustBook : false;
  const isClearAllDisabled = isTab2 ? !hasAnyTempFilterValue : false;
  // Modified fetchSecondTableData
  const fetchSecondTableData = useCallback(async () => {
    if (
      !selectedContractMonth ||
      !selectedDerivative ||
      !selectedContractName ||
      !selectedUnit
    ) {
      setSecondTableData([]);
      setThirdTableData([]);
      setIsLoadingSecond(false);
      setErrorMessage("Please select a valid unit and all required filters");
      return;
    }

    try {
      setIsLoadingSecond(true);
      setErrorMessage(null);

      const formattedDate = formatDateToFullYear(selectedContractMonth);
      const tradeUnit = unitMap[selectedUnit] || LOTS_STATEMENT;
      const tradeTypeParam = selectedTradeType.values && selectedTradeType.values.length > 0
        ? selectedTradeType.values.join(",")
        : "";

      const ClearingAccountParam = selectedClearingAccount.values && selectedClearingAccount.values.length > 0
        ? selectedClearingAccount.values.join(",")
        : "";

      const customerAccountParam = selectedCustomerAccount.values?.length > 0
        ? selectedCustomerAccount.values.join(",") : "";

      const params = new URLSearchParams({
        date_str: formattedDate,
        derivatives: selectedDerivative,
        contract_name: selectedContractName,
        trade_unit: tradeUnit,
      });
      if (selectedBook) params.append(BOOK, selectedBook);
      if (selectedDate) params.append(TILL_DATE, selectedDate);
      if (selectedClearer) params.append(CLEARER, selectedClearer);
      if (selectedStrategy) params.append(STRATEGY, selectedStrategy);
      if (selectedTradeType) params.append(TRADE_TYPE, tradeTypeParam);
      if (selectedClearingAccount) params.append(CLEARING_ACCOUNT, ClearingAccountParam);
      if (selectedCustomerAccount) params.append(ACCOUNT, customerAccountParam);
      if (selectedCustBook) params.append(CUST_BOOK, selectedCustBook);

      const url = `/paper-app/transactions-summary/?${params.toString()}`;
      const response = await axiosInstance.get(url);
      let apiData = response.data;

      if (!Array.isArray(apiData)) {
        if (apiData?.data && Array.isArray(apiData.data))
          apiData = apiData.data;
        else if (apiData?.results && Array.isArray(apiData.results))
          apiData = apiData.results;
        else if (apiData && typeof apiData === OBJECT) apiData = [apiData];
        else apiData = [];
      }

      const formattedData = apiData.map((item: any) => ({
        derivative: item.derivative || "",
        contract_name: item.contract_name || "",
        contract_month: item.contract_month || "",
        buy: item.buy || 0,
        sell: item.sell || 0,
      }));

      setSecondTableData(formattedData);
      setThirdTableData([]);
      if (formattedData.length === 0)
        setErrorMessage("No data available for the selected filters");
    } catch (error: any) {
      console.error("Error fetching second table data:", error);
      setSecondTableData([]);
      setErrorMessage(error.message || "Failed to fetch transaction data");
    } finally {
      setIsLoadingSecond(false);
    }
  }, [
    selectedContractMonth,
    selectedDerivative,
    selectedContractName,
    selectedUnit,
    selectedBook,
    selectedClearer,
    selectedStrategy,
    selectedTradeType,
    selectedClearingAccount,
    selectedCustomerAccount,
    selectedCustBook,
    selectedDate,
  ]);

  const fetchThirdTableData = useCallback(
    async (params: {
      date_str: string;
      derivatives: string;
      contract_name: string;
      buy_sell: string;
    }) => {
      if (!selectedUnit) {
        setThirdTableData([]);
        setIsLoadingSecond(false);
        setErrorMessage("Please select a valid unit");
        return;
      }

      try {
        setIsLoadingSecond(true);
        setErrorMessage(null);

        const { date_str, derivatives, contract_name, buy_sell } = params;
        const tradeUnit = unitMap[selectedUnit] || LOTS_STATEMENT;
        const tradeTypeParam = selectedTradeType.values && selectedTradeType.values.length > 0
          ? selectedTradeType.values.join(",")
          : "";

        const ClearingAccountParam = selectedClearingAccount.values && selectedClearingAccount.values.length > 0
          ? selectedClearingAccount.values.join(",")
          : "";

        const customerAccountParam = selectedCustomerAccount.values && selectedCustomerAccount.values.length > 0
          ? selectedCustomerAccount.values.join(",")
          : "";

        const qs = new URLSearchParams({
          date_str,
          derivatives,
          contract_name,
          buy_sell,
          trade_unit: tradeUnit,
        });
        if (selectedBook) qs.append(BOOK, selectedBook);
        if (selectedDate) qs.append(TILL_DATE, selectedDate);
        if (selectedClearer) qs.append(CLEARER, selectedClearer);
        if (selectedStrategy) qs.append(STRATEGY, selectedStrategy);
        if (selectedTradeType) qs.append(TRADE_TYPE, tradeTypeParam);
        if (selectedClearingAccount) qs.append(CLEARING_ACCOUNT, ClearingAccountParam);
        if (selectedCustomerAccount) qs.append(ACCOUNT, customerAccountParam);
        if (selectedCustBook) qs.append(CUST_BOOK, selectedCustBook);

        const url = `/paper-app/filter-transactions/?${qs.toString()}`;
        const response = await axiosInstance.get(url);
        let apiData = response.data;

        if (!Array.isArray(apiData)) {
          if (apiData?.data && Array.isArray(apiData.data))
            apiData = apiData.data;
          else if (apiData?.results && Array.isArray(apiData.results))
            apiData = apiData.results;
          else if (apiData && typeof apiData === OBJECT) apiData = [apiData];
          else apiData = [];
        }

        const formattedData = apiData.map((item: any) => ({
          formatted_date: item.formatted_date || "",
          pricing_from_formatted: item.pricing_from_formatted || "",
          pricing_to_formatted: item.pricing_to_formatted || "",
          book_name_resolved: item.book_name_resolved || "",
          customer_company_name_resolved:
            item.customer_company_name_resolved || "",
          trader_type: item.trader_type || "",
          exec_id: item.exec_id || "",
          leg_id: item.leg_id || "",
          quantity: item.quantity || 0,
          buy_sell: item.buy_sell || "",
          tick: item.tick || 0,
          price: item.price || 0,
          approx_exec_price: item.approx_exec_price || 0,
          customer_account: item.customer_account || "",
          derivative: item.derivative || "",
          single_diff: item.single_diff || "",
          trader_name: item.trader_name || "",
          contract_type_name: item.contract_type_name || "",
          clearer_rate_display: item.clearer_rate_display || "",
          clearer_name: item.clearer_name || "",
          clearing_account_name: item.clearing_account_name || "",
          unit_name: item.unit_name || "",
          commodity_name: item.commodity_name || "",
          holiday_name: item.holiday_name || "",
          broker_name: item.broker_name || "",
          strategy_name: item.strategy_name || "",
          customer_company_name: item.customer_company_name || "",
          status: item.status || "",
          parent_company: item.parent_company || "",
          bbl_conversion_value: item.bbl_conversion_value || 0,
          bbl: item.bbl || 0,
          kbbl: item.kbbl || 0,
          exchange_fee: item.exchange_fee || 0,
          clearing_house_fee: item.clearing_house_fee || 0,
          total_fee: item.total_fee || 0,
          total_no_days: item.total_no_days || "",
          priced_days: item.priced_days || "",
          unpriced_days: item.unpriced_days || "",
          priced_volume: item.priced_volume || "",
          unpriced_volume: item.unpriced_volume || "",
          unpriced_kbbl: item.unpriced_kbbl || "",
          brokerage: item.brokerage || 0,
          mtm: item.mtm || 0,
          pnl: item.pnl || 0,
          mtm_yesterday: item.mtm_yesterday || 0,
          net_pnl: item.net_pnl || 0,
          ltd: item.ltd || "",
          cust_book_name: item.cust_book_name || "",
          internal_strategy_name: item.internal_strategy_name || "",
          internal_clearer_name: item.internal_clearer_name || "",
          internal_cust_book_name: item.internal_cust_book_name || "",
          internal_book_name: item.internal_book_name || "",
          first_month_formatted: item.first_month_formatted || "",
          second_month_formatted: item.second_month_formatted || "",
          futures_equiv_first_kbbl: item.futures_equiv_first_kbbl || 0,
          futures_equiv_second_kbbl: item.futures_equiv_second_kbbl || 0,
        }));

        setThirdTableData(formattedData);
        if (formattedData.length === 0)
          setErrorMessage("No data available for the selected filters");
      } catch (error: any) {
        console.error("Error fetching third table data:", error);
        setThirdTableData([]);
        setErrorMessage(error.message || "Failed to fetch deal data");
      } finally {
        setIsLoadingSecond(false);
      }
    },
    [
      selectedUnit,
      selectedBook,
      selectedDate,
      selectedClearer,
      selectedStrategy,
      selectedTradeType,
      selectedClearingAccount,
      selectedCustomerAccount,
      selectedCustBook,
    ]
  );


  //Fetch data when selectedDate changes
  // useEffect(() => {
  //   if (selectedDate) {
  //     fetchData(selectedDate);
  //   }
  // }, [selectedDate]);

  // Fetch second table data when filter parameters change
  // With this fixed version:
  useEffect(() => {
    // Only fetch second table data when all required filters are present
    if (selectedContractMonth && selectedDerivative && selectedContractName) {
      fetchSecondTableData();
    }
  }, [selectedContractMonth, selectedDerivative, selectedContractName]);



  // Modified handleDateChange function

  // Keep the existing useEffect for selectedUnit but ensure it resets second table
  useEffect(() => {
    if (!selectedUnit) {
      // Reset second table data and filters when unit is reset to default
      resetSecondTableData();
    }
  }, [selectedUnit]);

  useEffect(() => {
    if (selectedTradeType.values.length === 0 && !selectedTradeType.isAll) {
      resetSecondTableData();
    }
  }, [selectedTradeType]);

  // Add this useEffect to reset second table data when selectedClearingAccount changes
  useEffect(() => {
    if (selectedClearingAccount.values.length === 0 && !selectedClearingAccount.isAll) {
      resetSecondTableData();
    }
  }, [selectedClearingAccount]);

  // Modified initial useEffect - remove automatic data fetching
  useEffect(() => {
    // Fetch default data (lots/statement) and second table data
    fetchData();
    fetchSecondTableData();
  }, []);
  const handleExportSecondTable = async () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("SecondTable");

    // 1️⃣ Headers
    const headers = secondTableColumns.map(
      (col) => col.header || col.accessorKey
    );
    worksheet.addRow(headers);

    // 2️⃣ Data rows
    secondTableData.forEach((row) => {
      const rowValues = secondTableColumns.map((col) => {
        const key = col.accessorKey;
        return key !== undefined ? row[key] ?? "" : "";
      });

      // Add the row first
      const excelRow = worksheet.addRow(rowValues);

      // Find column indexes for Buy and Sell
      const buyIndex =
        secondTableColumns.findIndex((c) => c.accessorKey === BUY) + 1;
      const sellIndex =
        secondTableColumns.findIndex((c) => c.accessorKey === SELL) + 1;

      // Style each cell
      excelRow.eachCell((cell, colNumber) => {
        // Default border
        cell.border = {
          top: { style: "thin" },
          bottom: { style: "thin" },
          left: { style: "thin" },
          right: { style: "thin" },
        };

        // Buy column styling
        if (colNumber === buyIndex) {
          cell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "E2F0D9" }, // light green background
          };
          const val = parseFloat(cell.value as string);
          if (!isNaN(val)) {
            cell.font = {
              color: { argb: val >= 0 ? "008000" : "FF0000" }, // green or red font
            };
          }
        }

        // Sell column styling
        else if (colNumber === sellIndex) {
          cell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "FCE4D6" }, // light red background
          };
          const val = parseFloat(cell.value as string);
          if (!isNaN(val)) {
            cell.font = {
              color: { argb: val >= 0 ? "008000" : "FF0000" }, // green or red font
            };
          }
        }

        // Non-buy/sell numeric cells → align right (optional)
        else {
          cell.alignment = { horizontal: "left" };
        }
      });
    });

    // 3️⃣ Auto column width
    worksheet.columns.forEach((col) => {
      if (col?.eachCell) {
        let max = 0;
        col.eachCell({ includeEmpty: true }, (cell) => {
          const v = cell.value ? cell.value.toString() : "";
          max = Math.max(max, v.length);
        });
        if (max > 0) {
          col.width = max + 2;
        }
      }
    });

    // 4️⃣ Save file
    const buffer = await workbook.xlsx.writeBuffer();
    saveAs(
      new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      }),
      `Transaction_Summary_${generateExportFileName()}`
    );
  };
  const handleExportThirdTable = async (
    thirdTableColumns: any[],
    thirdTableData: any[]
  ) => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("ThirdTable");

    // 1️⃣ Add header row
    const headers = thirdTableColumns.map(
      (col) => col.header || col.accessorKey
    );
    worksheet.addRow(headers);

    // 2️⃣ Determine indexes for special styling
    const buySellIndex =
      thirdTableColumns.findIndex((c) => c.accessorKey === BUY_SELL) + 1; // ExcelJS is 1-based
    const quantityIndex =
      thirdTableColumns.findIndex((c) => c.accessorKey === QUANTITY) + 1;
    const derivativeIndex =
      thirdTableColumns.findIndex((c) => c.accessorKey === DERIVATIVE) + 1;

    // 3️⃣ Map derivative → background color (same as MRT)
    const derivativeColors: Record<string, string> = {
      swaps: "FFFFFF", // Light green
      futures: "FFFFFF", // Transparent / white
      default: "FFFFFF",
    };

    // 4️⃣ Add data rows with styling
    thirdTableData.forEach((row) => {
      // Values in same order as columns
      const rowValues = thirdTableColumns.map((col) => {
        const key = col.accessorKey;
        return key !== undefined ? row[key] ?? "" : "";
      });

      const excelRow = worksheet.addRow(rowValues);

      excelRow.eachCell((cell, colNumber) => {
        // Border for all cells
        cell.border = {
          top: { style: "thin" },
          bottom: { style: "thin" },
          left: { style: "thin" },
          right: { style: "thin" },
        };

        // 4a️⃣ Derivative row background
        if (colNumber === derivativeIndex) {
          const derivativeVal = cell.value as string;
          const bg =
            derivativeColors[derivativeVal?.toLowerCase()] ||
            derivativeColors.default;
          cell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: bg },
          };
        }

        // 4b️⃣ Buy/Sell column → green or red background
        if (colNumber === buySellIndex) {
          const val = (cell.value as string)?.toLowerCase();
          const bg =
            val === "buy"
              ? "E2F0D9" // light green
              : val === "sell"
                ? "FCE4D6" // light red
                : "FFFFFF";
          cell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: bg },
          };
          // Font color
          cell.font = {
            color: {
              argb:
                val === BUY ? "008000" : val === SELL ? "FF0000" : "000000",
            },
          };
        }

        // 4c️⃣ Quantity → numeric formatting and font color
        if (colNumber === quantityIndex) {
          const num = parseFloat(cell.value as string);
          if (!isNaN(num)) {
            cell.alignment = { horizontal: "right" };
            cell.font = {
              color: { argb: num >= 0 ? "008000" : "FF0000" }, // green or red font
            };
          }
        }
      });
    });

    worksheet.columns.forEach((col) => {
      if (col?.eachCell) {
        let max = 0;
        col.eachCell({ includeEmpty: true }, (cell) => {
          const v = cell.value ? cell.value.toString() : "";
          max = Math.max(max, v.length);
        });
        if (max > 0) {
          col.width = max + 2;
        }
      }
    });

    const buffer = await workbook.xlsx.writeBuffer();
    saveAs(
      new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      }),
      `Deals_${generateExportFileName()}`
    );
  };

  useEffect(() => {
    if (selectedDate) {
      resetSecondTableData();
      const tradeTypeParam = selectedTradeType.values && selectedTradeType.values.length > 0
        ? selectedTradeType.values.join(",")
        : "";
      const clearingAccountParam = selectedClearingAccount.values && selectedClearingAccount.values.length > 0
        ? selectedClearingAccount.values.join(",")
        : "";

      const customerAccountParam = selectedCustomerAccount.values && selectedCustomerAccount.values.length > 0
        ? selectedCustomerAccount.values.join(",")
        : "";

      if (selectedUnit === "30") {
        fetchLotsPositionData(
          selectedDate,
          selectedBook,
          selectedClearer,
          selectedStrategy,
          tradeTypeParam,
          clearingAccountParam,
          customerAccountParam,
          selectedCustBook
        );
      } else if (selectedUnit === "10") {
        fetchKbblData(
          selectedDate,
          selectedBook,
          selectedClearer,
          selectedStrategy,
          tradeTypeParam,
          clearingAccountParam,
          customerAccountParam,
          selectedCustBook
        );
      } else {
        fetchData(
          selectedDate,
          selectedBook,
          selectedClearer,
          selectedStrategy,
          tradeTypeParam,
          clearingAccountParam,
          customerAccountParam,
          selectedCustBook
        );
      }
    }
  }, [
    selectedDate,
    selectedUnit,
    selectedBook,
    selectedClearer,
    selectedStrategy,
    selectedTradeType,
    selectedClearingAccount,
    selectedCustomerAccount,
    selectedCustBook,
  ]);

  // Utility to create a default column configuration for the second table
  const createColumnConfig = (
    accessorKey: string,
    header: string,
    overrides: Partial<MRT_ColumnDef<any>> = {}
  ): MRT_ColumnDef<any> => ({
    accessorKey,
    header,
    enableEditing: false,
    filterVariant: "text",
    muiTableBodyCellProps: ({ row, table }) => ({
      sx: {
        cursor: "pointer",
        "&:hover": {
          backgroundColor: "rgba(44, 4, 4, 0.05)",
        },
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
      },
    }),
    ...overrides,
  });

  // Columns for the second table
  const secondTableColumns = useMemo<MRT_ColumnDef<any>[]>(
    () => [
      createColumnConfig(DERIVATIVE, "Derivative", {
        muiTableBodyCellProps: {
          className: "derivative-cell",
        },
      }),
      createColumnConfig(CONTRACT_NAME, "Contract Name"),
      createColumnConfig("contract_month", "Contract Month"),
      createColumnConfig(BUY, "Buy", {
        Cell: ({ cell }: { cell: MRT_Cell<any> }) => {
          const rawValue = cell.getValue();
          const isNumeric =
            !isNaN(parseFloat(rawValue as string)) && isFinite(rawValue as any);
          const value = isNumeric ? parseFloat(rawValue as string) : 0;

          const color = isNumeric
            ? value < 0
              ? "#e02848"
              : value === 0
                ? "gray"
                : "black"
            : "gray";

          return (
            <Box
              component="span"
              sx={{
                fontWeight: "normal",
                color,
                padding: "0px 5px",
                borderRadius: "18px",
              }}
            >
              {isNumeric ? value.toFixed(2) : String(rawValue || "-")}
            </Box>
          );
        },
        muiTableBodyCellProps: {
          sx: {
            cursor: "pointer",
            "&:hover": {
              backgroundColor: "transparent", // ✅ no hover background
            },
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            border: "1px solid #ebe9e98f",
          },
        },
      }),
      createColumnConfig("sell", "Sell", {
        Cell: ({ cell }: { cell: MRT_Cell<any> }) => {
          const value = safeParseFloat(cell.getValue());
          const color = value < 0 ? "#e02848" : value === 0 ? "gray" : "black"; // ✅ no green

          return (
            <Box
              component="span"
              sx={{
                fontWeight: "normal",
                color,
                padding: "0px 5px",
                borderRadius: "18px",
              }}
            >
              {value.toFixed(2)}
            </Box>
          );
        },
        muiTableBodyCellProps: {
          sx: {
            cursor: "pointer",
            "&:hover": {
              backgroundColor: "transparent", // ✅ no hover background
            },
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            border: "1px solid #ebe9e98f",
          },
        },
      }),
    ],
    []
  );

  const thirdTableColumns = useMemo<MRT_ColumnDef<any>[]>(
    () => [
      createColumnConfig("status", "Status", {
        Cell: ({ cell }) => {
          const rawValue = cell.getValue();
          const value =
            rawValue && typeof rawValue === "string"
              ? rawValue.trim()
              : String(rawValue ?? "N/A").trim();

          const normalized = value.toLowerCase();

          let bgColor = "#e0e0e0"; // default background
          let textColor = "#000000"; // default text

          if (normalized === "pending") {
            bgColor = "#FFB74D"; // Dark Amber
            textColor = "#4E342E"; // Dark Brownish text
          } else if (normalized === "rejected") {
            bgColor = "#E53935"; // Strong Red
            textColor = "#FFFFFF"; // White text for contrast
          } else if (normalized === "validated") {
            bgColor = "#43A047"; // Deep Green
            textColor = "#FFFFFF";
          } else if (normalized === "committed") {
            bgColor = "#1E88E5"; // Medium/Dark Blue
            textColor = "#FFFFFF";
          }

          const displayValue =
            value && value !== "N/A"
              ? value.charAt(0).toUpperCase() + value.slice(1)
              : "N/A";

          return (
            <Chip
              label={displayValue}
              size="small"
              sx={{
                backgroundColor: bgColor,
                color: textColor,
              }}
            />
          );
        },
      }),
      createColumnConfig("formatted_date", "Trade Date", {
        // minSize: 60,
      }),
      createColumnConfig("trader_name", "Trader", {
        // filterSelectOptions: ["Single", "Diff"],
      }),

      createColumnConfig("exec_id", "Exed ID", {
        filterSelectOptions: ["Major", "Mini"],
      }),
      createColumnConfig("leg_id", "leg ID", { size: 250 }),
      createColumnConfig("book_name_resolved", "Book"),
      createColumnConfig("strategy_name", STRATEGY),
      createColumnConfig(BUY_SELL, "Buy/Sell", {
        muiTableBodyCellProps: {
          className: "buy_sell-cell",
        },
        Cell: ({ cell }) => {
          const value = cell.getValue<string>();
          const badgeClass =
            value?.toLowerCase() === BUY
              ? "badge badge-success"
              : value?.toLowerCase() === SELL
                ? "badge badge-danger"
                : "badge";
          return <span className={badgeClass}>{value || "N/A"}</span>;
        },
      }),

      createColumnConfig(QUANTITY, "Quantity"),
      createColumnConfig("commodity_name", "Commodity Type"),
      createColumnConfig(DERIVATIVE, "Derivative", {
        muiTableBodyCellProps: {
          className: "derivative-cell",
        },
        muiEditTextFieldProps: ({ row, table }) => ({
          required: true,
          select: true,
          value: row.getValue(DERIVATIVE) ?? "",
          error: !!validationErrors?.derivative,
          helperText: validationErrors?.derivative,
          onFocus: () =>
            setValidationErrors((prev) => ({
              ...prev,
              derivative: undefined,
            })),
          onChange: (e) => {
            const newValue = e.target.value;
            row._valuesCache[DERIVATIVE] = newValue;
            row.original.derivative = newValue;
          },
          children: ["value-2", "value-3"].map((option) => (
            <MenuItem key={option} value={option}>
              {option}
            </MenuItem>
          )),
        }),
      }),
      createColumnConfig("unit_name", "Unit", {
        muiTableBodyCellProps: ({ row, table }) => ({
          className: "paper-trading-Unit",
          fontSize: "0.65rem",
          onDoubleClick: undefined,
          sx: {
            cursor: "pointer",
            "&:hover": {
              backgroundColor: "rgba(44, 4, 4, 0.05)",
            },
            ...(table.getState().editingRow?.id === row.id && {
              backgroundColor: "rgba(0, 128, 0, 0.1)",
              transition: "background-color 0.3s ease",
            }),
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          },
        }),
      }),
      createColumnConfig("pricing_from_formatted", "Pricing From"),
      createColumnConfig("pricing_to_formatted", "Pricing To"),
      createColumnConfig("price", "Price"),
      createColumnConfig("holiday_name", "Holiday"),
      createColumnConfig("bbl_conversion_value", "kbbl Conversion Factor", {
        // size: 300,
      }),
      createColumnConfig("bbl", "bbl"),
      createColumnConfig(KBBL, KBBL),
      createColumnConfig("priced_days", "Priced Days"),
      createColumnConfig("unpriced_days", "Unpriced Days", {
        Cell: ({ cell }) => {
          const value = cell.getValue<number>();
          return value != null ? Number(value).toFixed(2) : "N/A";
        },
      }),

      createColumnConfig("total_no_days", "Total Trading Days"),
      createColumnConfig("priced_volume", "Priced Volume", {
        Cell: ({ cell }) => {
          const value = cell.getValue<number>();
          return value != null ? Number(value).toFixed(2) : "N/A";
        },
      }),
      createColumnConfig("unpriced_volume", "Unpriced Volume", {
        Cell: ({ cell }) => {
          const value = cell.getValue<number>();
          return value != null ? Number(value).toFixed(2) : "N/A";
        },
      }),
      createColumnConfig("unpriced_kbbl", "Unpriced kbbl", {
        Cell: ({ cell }) => {
          const value = cell.getValue<number>();
          return value != null ? Number(value).toFixed(2) : "N/A";
        },
      }),
      createColumnConfig("first_month_formatted", "First-Month"),
      createColumnConfig("second_month_formatted", "Second Month"),
      createColumnConfig("futures_equiv_first_kbbl", "First Month Equiv kbbl"),
      createColumnConfig("futures_equiv_second_kbbl", "Second Month Equiv kbbl"),
      createColumnConfig("clearer_name", "Clearer Name"),
      createColumnConfig("clearing_account_name", "Clearing Account Reference"),
      createColumnConfig("customer_company_name_resolved", "Customer Company"),
      createColumnConfig("customer_account", "Customer Account"),
      createColumnConfig("parent_company", "Parent Company"),
      createColumnConfig("internal_strategy_name", "Internal Strategy"),
      createColumnConfig("internal_book_name", "Internal Book"),
      createColumnConfig("single_diff", "Single Diff", {
        Cell: ({ cell }) => {
          const value = cell.getValue() as string;
          // Capitalize first letter of each word
          return value
            .split("_")
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
            .join(" ");
        },
      }),

      createColumnConfig("trader_type", "Trade Type", {
        filterSelectOptions: ["Major", "Mini"],
        muiTableBodyCellProps: {
          className: "trader_type-cell",
        },
        muiEditTextFieldProps: ({ row, table }) => ({
          required: true,
          select: true,
          value: row.getValue("trader_type") ?? "",
          error: !!validationErrors?.trader_type,
          helperText: validationErrors?.trader_type,
          onFocus: () =>
            setValidationErrors((prev) => ({
              ...prev,
              trader_type: undefined,
            })),
          onChange: (e) => {
            const newValue = e.target.value;
            row._valuesCache["trader_type"] = newValue;
            row.original.trader_type = newValue;
          },
          children: ["value-2", "value-3"].map((option) => (
            <MenuItem key={option} value={option}>
              {option}
            </MenuItem>
          )),
        }),
      }),

      createColumnConfig("contract_type_name", "Contract Type", {
        // Optional: filter options in header
        filterSelectOptions: ["Major", "Mini"],

        // Column header explicitly
        header: "Contract Type",

        // Cell editing props
        muiEditTextFieldProps: ({ row }) => ({
          required: true,
          select: true,
          value: row.getValue("contract_type_name") ?? "",
          error: !!validationErrors?.contract_type_name,
          helperText: validationErrors?.contract_type_name,
          onFocus: () =>
            setValidationErrors((prev) => ({
              ...prev,
              contract_type_name: undefined,
            })),
          onChange: (e) => {
            const newValue = e.target.value;
            row._valuesCache["contract_type_name"] = newValue;
            row.original.contract_type_name = newValue;
          },
          children: ["Major", "Mini"].map((option) => (
            <MenuItem key={option} value={option}>
              {option}
            </MenuItem>
          )),
        }),
      }),
      createColumnConfig("ltd_formatted", "LTD"),
      // createColumnConfig("broker_name", "Broker"),
    ],
    []
  );
  const fourthTableColumns = useMemo<MRT_ColumnDef<any>[]>(
    () => [
      createColumnConfig(CONTRACT_NAME, "Contract Name"),
      createColumnConfig(QUANTITY, "Quantity", {
        Cell: ({ cell }: { cell: MRT_Cell<any> }) => {
          const cellValue = cell.getValue();
          const value = safeParseFloat(cellValue); // Use existing safeParseFloat
          const color = value < 0 ? "#e02848" : value > 0 ? "black" : "gray";
          const bgColor =
            value < 0
              ? "#fef4f3"
              : value > 0
                ? "rgba(131, 191, 110, 0.15)"
                : "rgba(128, 128, 128, 0.1)";

          return (
            <Box
              component="span"
              sx={{
                fontWeight: "normal",
                color: color,
                // backgroundColor: bgColor,
                padding: "0px 5px",
                borderRadius: "18px",
              }}
            >
              {value.toFixed(2)} {/* Round to 2 decimal places */}
            </Box>
          );
        },
        muiTableBodyCellProps: {
          sx: {
            cursor: "pointer",
            "&:hover": {
              backgroundColor: "rgba(44, 4, 4, 0.05)",
            },
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            border: "1px solid #ebe9e98f",
          },
        },
      }),
    ],
    []
  );
  // ... existing imports and code ...

  const filteredTableData =
    activeTab === 1
      ? selectedUnit && selectedCustBook
        ? tableData
        : []
      : tableData;
  const filteredColumns = useMemo<MRT_ColumnDef<User>[]>(() => {
    // inside your filteredColumns useMemo
    const isNumericValue = (val: any) =>
      val !== null &&
      val !== undefined &&
      !isNaN(parseFloat(val)) &&
      isFinite(val);

    const getVisibleHeaders = (headers: string[]) => {
      return headers.filter((header) => {
        const key = createSafeKey(header);
        const values = filteredTableData.map((row: any) => row[key]);

        return values.some((v) => isNumericValue(v) && parseFloat(v) !== 0);
      });
    };

    const uniqueHeadersWithDerivatives =
      getUniqueHeadersWithDerivatives(originalApiData);
    const { futures, swaps } = categorizeHeaders(uniqueHeadersWithDerivatives);

    const visibleFutures = getVisibleHeaders(futures);

    const visibleSwaps = getVisibleHeaders(swaps);

    const createColumnDef = (headerName: string, isFuturesColumn: boolean): MRT_ColumnDef<User> => {
      const safeKey = createSafeKey(headerName);
      return {
        accessorKey: safeKey,
        id: safeKey,
        header: headerName,
        size: 160, // Default width
        minSize: 160, // ✅ FIXED: Set minSize = size to prevent resizing
        maxSize: 160, // ✅ FIXED: Set maxSize = size to prevent resizing
        enableResizing: false,
        Cell: ({ cell }: { cell: MRT_Cell<User> }) => {
          const rawValue = cell.getValue();
          const isNumeric =
            !isNaN(parseFloat(rawValue as string)) && isFinite(rawValue as any);
          const value = isNumeric ? parseFloat(rawValue as string) : 0;

          const color = isNumeric
            ? value < 0
              ? "#e02848"
              : value > 0
                ? "black"
                : "gray"
            : "gray";

          const bgColor = isNumeric
            ? value < 0
              ? "#fef4f3"
              : value > 0
                ? "rgba(131, 191, 110, 0.15)"
                : "rgba(128, 128, 128, 0.1)"
            : "transparent";

          return (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "10px",
                position: "relative",
              }}
            >
              {/* MAIN VALUE BUBBLE */}
              <Box
                component="span"
                onClick={() => handleCellClick(cell)}
                sx={{
                  fontWeight: "normal",
                  color,
                  backgroundColor: bgColor,
                  padding: "0px 5px",
                  borderRadius: "18px",
                  cursor: "pointer",
                  display: "inline-block",
                }}
              >
                {isNumeric ? value.toFixed(2) : String(rawValue || "-")}
              </Box>

              {/* HOVER ACTION BUTTONS */}
              {(selectedUnit === "30" || selectedUnit === "10") && (
                <Box
                  sx={{
                    display: "none",
                    ".MuiTableCell-root:hover &": {
                      display: "inline-flex",
                    },
                  }}
                >
                  {/* GREEN BUTTON → if NOT (selectedUnit === 10 AND future column) */}
                  {!isFuturesColumn && (
                    <IconButton
                      size="small"
                      sx={{ padding: 0, color: "#038d3d" }}
                      onClick={() => handleButtonClick(cell)}
                    >
                      <AddCircleOutlineIcon fontSize="small" />
                    </IconButton>
                  )}

                  {/* BLUE BUTTON → only when selectedUnit = 10 AND isFutureColumn = true */}
                  {selectedUnit === "10" && isFuturesColumn && (
                    <IconButton
                      size="small"
                      sx={{ padding: 0, ml: 0.5, color: "#0b57ff" }}
                      onClick={() => handleButtonClick(cell, true)}
                    >
                      <AddCircleOutlineIcon fontSize="small" />
                    </IconButton>
                  )}
                </Box>
              )}
            </Box>
          );
        },
        Footer: ({ table }: any) => {
          const total = calculateTotal(
            table
              .getPrePaginationRowModel()
              .rows.map((row: any) => row.original),
            safeKey
          );
          const color = total < 0 ? "red" : total > 0 ? "black" : "gray";
          const bgColor = "transparent";
          return (
            <Box
              component="span"
              sx={{
                fontWeight: "bold",
                color,
                backgroundColor: bgColor,
                padding: "0px 5px",
                borderRadius: "18px",
                marginLeft: "10px",
              }}
            >
              {total.toFixed(2)}
            </Box>
          );
        },
      };
    };

    // Contract and Total columns (common for both tabs)
    const contractColumn: MRT_ColumnDef<User> = {
      accessorKey: CONTRACT_MONTH,
      header: "Contract Month",
      size: 160,
      minSize: 160, // ✅ FIXED: Match size
      maxSize: 160,
      enableResizing: false,
      enableColumnDragging: true,
      Cell: ({ cell }: { cell: MRT_Cell<User> }) => (
        <span>{cell.getValue() as string}</span>
      ),
      Footer: ({ table }: any) => (
        <Box sx={{ fontWeight: "bold", color: "black" }}>
          Total: ({totalUnitLabel?.label || ""})
        </Box>
      ),
    };

    const totalColumn: MRT_ColumnDef<User> = {
      accessorKey: "Total_kbbl",
      header: `Total: (${totalUnitLabel?.label || ""})`,
      size: 160,
      minSize: 160, // ✅ FIXED: Match size
      maxSize: 160,
      Cell: ({ cell }: { cell: MRT_Cell<User> }) => {
        const value = safeParseFloat(cell.getValue());
        const color = value < 0 ? "#e02848" : "black"; // ✅ no green text
        const bgColor =
          value < 0
            ? "#fef4f3" // light red for negative
            : "rgba(128, 128, 128, 0.1)"; // ✅ neutral background for positive/zero

        return (
          <Box
            component="span"
            onClick={() => handleCellClick(cell)}
            sx={{
              fontWeight: "normal",
              color,
              backgroundColor: bgColor,
              padding: "0px 5px",
              borderRadius: "18px",
              display: "inline-block",
            }}
          >
            {value.toFixed(2)}
          </Box>
        );
      },
      Footer: ({ table }: any) => {
        const total = calculateTotal(
          table.getPrePaginationRowModel().rows.map((row: any) => row.original),
          "Total_kbbl"
        );
        const color = total < 0 ? "red" : "black"; // ✅ no green
        const bgColor = "transparent";

        return (
          <Box
            component="span"
            sx={{
              fontWeight: "bold",
              color,
              backgroundColor: bgColor,
              padding: "0px 5px",
              borderRadius: "18px",
              marginLeft: "15px",
            }}
          >
            {total.toFixed(2)}
          </Box>
        );
      },
    };

    // Customer Tab
    if (activeTab === 1) {
      if (!selectedUnit || !selectedCustBook) return [];
      const uniqueHeadersWithDerivatives =
        getUniqueHeadersWithDerivatives(originalApiData);
      const { futures, swaps } = categorizeHeaders(
        uniqueHeadersWithDerivatives
      );

      const allColumns: MRT_ColumnDef<User>[] = [
        { id: CONTRACT, header: "", columns: [contractColumn] },
        ...(visibleFutures.length > 0
          ? [
            {
              id: FUTURES,
              header: "Futures",
              columns: visibleFutures.map((h) => createColumnDef(h, true)),
            },
          ]
          : []),
        ...(visibleSwaps.length > 0
          ? [
            {
              id: SWAPS,
              header: "Swaps",
              columns: visibleSwaps.map((h) => createColumnDef(h, false)),
            },
          ]
          : []),
        { id: "totals", header: "Total", columns: [totalColumn] },
      ].filter((c) => c.columns.length > 0);

      return allColumns;
    }

    // Company Tab
    if (isLoading || originalApiData.length === 0) return [];

    const allColumns: MRT_ColumnDef<User>[] = [
      { id: CONTRACT, header: "", columns: [contractColumn] },
      ...(visibleFutures.length > 0
        ? [
          {
            id: FUTURES,
            header: "Futures",
            columns: visibleFutures.map((h) => createColumnDef(h, true)),
          },
        ]
        : []),
      ...(visibleSwaps.length > 0
        ? [
          {
            id: SWAPS,
            header: "Swaps",
            columns: visibleSwaps.map((h) => createColumnDef(h, false)),
          },
        ]
        : []),
      { id: "totals", header: "Total", columns: [totalColumn] },
    ].filter((c) => c.columns.length > 0);

    return allColumns;
  }, [
    activeTab,
    selectedUnit,
    selectedCustBook,
    isLoading,
    originalApiData,
    totalUnitLabel,
  ]);
  useEffect(() => {
    if (filteredColumns.length === 0) return;

    const leafIds: string[] = [];

    filteredColumns.forEach((group: any) => {
      if (group.columns && Array.isArray(group.columns)) {
        // It's a group — extract leaf columns inside it
        group.columns.forEach((col: any) => {
          const id = col.id || col.accessorKey;
          if (id && id !== 'Total_kbbl') {
            leafIds.push(id);
          }
        });
      } else {
        // It's a direct leaf column
        const id = group.id || group.accessorKey;
        if (id && id !== 'Total_kbbl') {
          leafIds.push(id);
        }
      }
    });

    // Always push Total_kbbl to the absolute end
    leafIds.push('Total_kbbl');

    // Only update if we have valid IDs
    if (leafIds.length > 1) {
      setColumnOrder(leafIds);
    }
  }, [filteredColumns]);


  const generateExportFileName = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()).padStart(2, '0');
    const dateString = `${year}-${month}-${day}`;

    const unitOptions = [
      { value: "", label: "Select" },
      { value: "10", label: KBBL },
      { value: "30", label: LOTS },
      { value: "40", label: LOTS_STATEMENT },
    ];

    let fileName = "Position";

    if (selectedUnit) {
      const unitOption = unitOptions.find((o) => o.value === selectedUnit);
      const unitLabel = unitOption?.label || selectedUnit;
      fileName += `_${unitLabel}`;
    }

    if (selectedCustBook && selectedCustBook !== "") {
      fileName += `_${selectedCustBook}`;
    }

    fileName += `_${dateString}`;

    return `${fileName}.xlsx`;
  };

  const handleExportExcelJS = async () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("TableData");

    let leafColumns = firstTable.getVisibleLeafColumns();

    leafColumns = leafColumns.filter(
      (col: any) => (col.columnDef.header || "").trim() !== ""
    );

    const headerRow = worksheet.addRow(
      leafColumns.map((col) => col.columnDef.header || "")
    );

    headerRow.eachCell((cell) => {
      cell.font = { bold: true };
    });

    firstTable.getRowModel().rows.forEach((row) => {
      const formattedRow = leafColumns.map((col) => {
        const value = row.getValue(col.id);

        const numeric =
          !isNaN(parseFloat(value as any)) && isFinite(value as any)
            ? parseFloat(value as any)
            : null;

        if (numeric !== null) return numeric.toFixed(2);
        return value || "-";
      });

      const bodyRow = worksheet.addRow(formattedRow);

      // Apply red for negative values
      bodyRow.eachCell((cell) => {
        const num = parseFloat(cell.value as string);
        if (!isNaN(num) && num < 0) {
          cell.font = { color: { argb: "FFFF0000" } }; // red text
        }
      });
    });

    const totalRow = leafColumns.map((col: any) => {
      const key = col.columnDef.accessorKey;

      if (key === CONTRACT_MONTH) {
        return `Total: (${totalUnitLabel?.label || ""})`;
      }

      const total = firstTable
        .getPrePaginationRowModel()
        .rows.reduce((acc, row) => {
          const v = row.original[key];
          const num = parseFloat(v as any);
          return isNaN(num) ? acc : acc + num;
        }, 0);

      return total.toFixed(2);
    });

    const footerRow = worksheet.addRow(totalRow);

    footerRow.eachCell((cell) => {
      cell.font = { bold: true };

      const num = parseFloat(cell.value as string);
      if (!isNaN(num) && num < 0) {
        cell.font = {
          bold: true,
          color: { argb: "FFFF0000" }, // red
        };
      }
    });

    leafColumns.forEach((col, index) => {
      const header = col.columnDef.header?.length || 10;
      worksheet.getColumn(index + 1).width = header + 10;
    });

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = generateExportFileName();
    link.click();
  };

  const firstTable = useMaterialReactTable({
    columns: filteredColumns,
    data: filteredTableData,
    enableDensityToggle: false,
    createDisplayMode: "row",
    editDisplayMode: "row",
    enableEditing: false,
    enableColumnOrdering: true,
    getRowId: (row) => row.contractMonth,
    enableColumnFilterModes: false,
    enablePagination: false,
    enableColumnDragging: true,        
    onColumnOrderChange: (newOrder: any) => {
      const updatedOrder = typeof newOrder === 'function'
        ? newOrder(columnOrder)
        : newOrder;

      // Remove both pinned columns from the middle
      const withoutPinned = updatedOrder.filter(
        (id: string) => id !== 'Total_kbbl' && id !== CONTRACT_MONTH
      );

      // contractMonth always first, Total_kbbl always last
      setColumnOrder([CONTRACT_MONTH, ...withoutPinned, 'Total_kbbl']);
    }, initialState: {
      showColumnFilters: false,
    },
    enableStickyFooter: true,
    enableColumnPinning: true,
    positionToolbarAlertBanner: "bottom",
    enableColumnResizing: false,
    columnResizeMode: "onEnd",

    defaultColumn: {
      size: 160, // <-- reduce from 160 to 160
      minSize: 160,
      maxSize: 160,
      enableResizing: false,
    },

    layoutMode: "grid",
    muiTableHeadCellProps: {
      sx: {
        cursor: "grab !important",
        "&:active": { cursor: "grabbing !important" },
        userSelect: "none !important",
        WebkitUserDrag: "none",
        border: "1px solid #e0e0e087",
        padding: "8px",
        fontWeight: "normal",

        whiteSpace: "normal !important",
        wordBreak: "break-word !important",
        overflowWrap: "break-word !important",
        lineHeight: 1.4,
        height: "auto",

        "& .mrt-table-head-cell-content": {
          display: "block !important",
          whiteSpace: "normal !important",
          wordBreak: "break-word !important",
          overflowWrap: "break-word !important",
          textAlign: "left",
        },

        "& .MuiBox-root": {
          whiteSpace: "normal !important",
          wordBreak: "break-word !important",
        },

        "& .mrt-column-actions-button": {
          display: "flex !important",
        },
        "& .mrt-resize-handle": {
          display: "none !important",
        },
      },
    },

    muiTableHeadProps: {
      sx: {
        "& th": {
          whiteSpace: "normal !important",
          wordBreak: "break-word !important",
          overflowWrap: "break-word !important",
        },
      },
    },

    muiTableBodyCellProps: {
      sx: {
        border: "1px solid #ebe9e98f",
        whiteSpace: "normal !important",
        wordBreak: "break-word !important",
        overflowWrap: "break-word !important",
        width: "160px !important",
        maxWidth: "160px !important",
        height: "auto !important", // ✅ ADD: Auto height
        verticalAlign: "top",
        padding: "8px",
      },
    },
    muiTablePaperProps: {
      elevation: 0,
      sx: { borderRadius: "0", border: "0" },
    },
    muiTopToolbarProps: {
      sx: {
        backgroundColor: "#fff",
        padding: "8px",
        "& .MuiBox-root.css-wsew38": {
          backgroundColor: "#fff",
          display: "flex",
          alignItems: "center",
          gap: "8px",
        },
      },
      className: "top-toolbar-wrapper__new",
    },
    muiTableContainerProps: {
      sx: {
        backgroundColor: "#fff",

        // ---------------------------------
        // HIDE COLUMN ACTIONS (3 dot menu)
        // ---------------------------------
        "& .mrt-column-actions-button": {
          display: "none !important",
        },

        // Existing styles...
        "& .MuiTable-root": {
          marginLeft: 0,
          marginRight: "auto",
          tableLayout: "fixed",
        },
      },
    },

    muiTableFooterProps: {
      sx: { backgroundColor: "#fff" },
      className: "table-footer-wrapper__new",
    },
    muiBottomToolbarProps: {
      sx: { backgroundColor: "#fff", padding: "8px" },
      className: "bottom-toolbar-wrapper__new",
    },
    // state: {      columnOrder: [
    //     'contract',
    //     'futures',
    //     'swaps',
    //     'totals',
    //   ], isLoading, showProgressBars: isLoading },
    state: {
      isLoading,
      showProgressBars: isLoading,
      columnOrder,  // always pass it directly
    }, renderTopToolbarCustomActions: () => (
      <Box sx={{ marginLeft: "auto", display: "flex", alignItems: "center" }}>
        <Tooltip title="Export">
          <IconButton color="primary" onClick={handleExportExcelJS}>
            <GetAppIcon />
          </IconButton>
        </Tooltip>
      </Box>
    ),
  });

  // Table instance for the second table
  const secondTable = useMaterialReactTable({
    columns: secondTableColumns,
    data: secondTableData,
    enableDensityToggle: false,
    createDisplayMode: "row",
    editDisplayMode: "row",
    enableEditing: false,
    enableColumnOrdering: true,
    enableRowOrdering: false,
    getRowId: (row) =>
      `${row.contract_month}-${row.contract_name}-${row.derivative}` ||
      Math.random().toString(),
    enableColumnFilterModes: false,
    initialState: { showColumnFilters: false },
    enableStickyFooter: true,
    enableColumnPinning: true,
    enablePagination: false,
    positionToolbarAlertBanner: "bottom",
    enableColumnResizing: true,
    enableStickyHeader: false,
    columnResizeMode: "onEnd",
    defaultColumn: { minSize: 50, enableResizing: true },

    muiTableBodyRowProps: ({ row, table }) => {
      const derivativeColors: Record<string, string> = {
        swaps: "transparent", // Light green for swaps
        futures: "transparent", // Light blue for futures
        default: "transparent", // Fallback color
      };

      const derivative = row.getValue(DERIVATIVE) as string;
      const backgroundColor =
        derivativeColors[derivative] || derivativeColors.default;

      return {
        onKeyDown: (event: React.KeyboardEvent<HTMLTableRowElement>) => {
          if (event.key === "Enter") {
            event.preventDefault();
            const editingRow = table.getState().editingRow;
            if (editingRow) {
              const saveHandler = table.options.onEditingRowSave;
              if (saveHandler) {
                const newedit = {
                  ...editingRow.original,
                  ...editingRow._valuesCache,
                };
                saveHandler({
                  exitEditingMode: () => table.setEditingRow(null),
                  row: editingRow,
                  table,
                  values: newedit,
                });
              }
            }
          }
        },
        sx: {
          backgroundColor,
          "&:hover": {
            backgroundColor: `color-mix(in srgb, ${backgroundColor}, #000000 10%)`,
          },
          ...(table.getState().editingRow?.id === row.id && {
            backgroundColor: "rgba(0, 128, 0, 0.1)",
            transition: "background-color 0.3s ease",
          }),
        },
      };
    },

    muiTableBodyCellProps: ({ cell, column, row }) => ({
      sx: {
        cursor: "pointer",
        "&:hover": {
          backgroundColor: "rgba(44, 4, 4, 0.05)",
        },
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        border: "1px solid #ebe9e98f",
      },
      onClick: () => {
        const rowData = row.original;
        const columnId = column.id;

        // ONLY FETCH DATA FOR BUY/SELL COLUMNS
        if (columnId === BUY || columnId === SELL) {
          setShowThirdTable(true);
          const buySellParam = columnId; // 'buy' or 'sell'

          fetchThirdTableData({
            date_str: formatDateToFullYear(rowData.contract_month),
            derivatives: rowData.derivative,
            contract_name: rowData.contract_name,
            buy_sell: buySellParam,
          });
        }
      },
    }),

    muiTableHeadCellProps: {
      sx: {
        border: "1px solid #e0e0e087",
        fontStyle: "italic",
        fontWeight: "normal",
      },
    },
    muiTablePaperProps: {
      elevation: 0,
      sx: { borderRadius: "0", border: "0" },
    },
    muiTopToolbarProps: {
      sx: {
        backgroundColor: "#fff",
        padding: "8px",
        "& .MuiBox-root.css-wsew38": {
          backgroundColor: "#fff",
          display: "flex",
          alignItems: "center",
          gap: "8px",
        },
      },
      className: "top-toolbar-wrapper__new",
    },
    muiTableContainerProps: {
      sx: { backgroundColor: "#fff" },
      className: "table-position__new",
    },
    muiTableFooterProps: {
      sx: { backgroundColor: "#fff" },
      className: "table-footer-wrapper__new",
    },
    muiBottomToolbarProps: {
      sx: { backgroundColor: "#fff", padding: "8px" },
      className: "bottom-toolbar-wrapper__new",
    },
    state: { isLoading: isLoadingSecond, showProgressBars: isLoadingSecond },
    renderTopToolbarCustomActions: () => (
      <Box sx={{ marginLeft: "auto", display: "flex", alignItems: "center" }}>
        <Tooltip title="Export">
          <IconButton color="primary" onClick={handleExportSecondTable}>
            <GetAppIcon />
          </IconButton>
        </Tooltip>
      </Box>
    ),
  });
  const thirdTable = useMaterialReactTable({
    columns: thirdTableColumns,
    data: thirdTableData,
    enableDensityToggle: false,
    createDisplayMode: "row",
    editDisplayMode: "row",
    enableEditing: false,
    enableColumnOrdering: true,
    enableRowOrdering: false,
    getRowId: (row) => row.id || row.exec_id || Math.random().toString(),
    enableColumnFilterModes: false,
    initialState: { showColumnFilters: false },
    enableStickyFooter: false,
    enablePagination: false,
    enableColumnPinning: true,
    positionToolbarAlertBanner: "bottom",
    enableColumnResizing: true,
    columnResizeMode: "onEnd",
    enableStickyHeader: false,
    defaultColumn: { minSize: 50, enableResizing: true },

    muiTableBodyRowProps: ({ row, table }) => {
      // Define color mapping for derivative values
      const derivativeColors: Record<string, string> = {
        swaps: "transparent", // Light green for swaps
        futures: "transparent", // Light blue for futures
        // Add more derivative types and colors as needed
        default: "transparent", // Fallback color
      };

      // Get the derivative value from the row
      const derivative = row.getValue(DERIVATIVE) as string;
      const backgroundColor =
        derivativeColors[derivative] || derivativeColors.default;

      return {
        onKeyDown: (event: React.KeyboardEvent<HTMLTableRowElement>) => {
          if (event.key === "Enter") {
            event.preventDefault();
            const editingRow = table.getState().editingRow;
            if (editingRow) {
              const saveHandler = table.options.onEditingRowSave;
              if (saveHandler) {
                const newedit = {
                  ...editingRow.original,
                  ...editingRow._valuesCache,
                };
                saveHandler({
                  exitEditingMode: () => table.setEditingRow(null),
                  row: editingRow,
                  table,
                  values: newedit,
                });
              }
            }
          }
        },
        sx: {
          backgroundColor, // Apply dynamic background color
          "&:hover": {
            backgroundColor: `color-mix(in srgb, ${backgroundColor}, #000000 10%)`, // Slightly darker on hover
          },
          ...(table.getState().editingRow?.id === row.id && {
            backgroundColor: "rgba(0, 128, 0, 0.1)", // Override for editing row
            transition: "background-color 0.3s ease",
          }),
        },
      };
    },
    muiTableHeadCellProps: {
      sx: {
        border: "1px solid #e0e0e087",
        fontStyle: "italic",
        fontWeight: "normal",
      },
    },
    muiTableBodyCellProps: { sx: { border: "1px solid #ebe9e98f" } },
    muiTablePaperProps: {
      elevation: 0,
      sx: { borderRadius: "0", border: "0" },
    },
    muiTopToolbarProps: {
      sx: {
        backgroundColor: "#fff",
        padding: "8px",
        "& .MuiBox-root.css-wsew38": {
          backgroundColor: "#fff",
          display: "flex",
          alignItems: "center",
          gap: "8px",
        },
      },
      className: "top-toolbar-wrapper__new",
    },
    muiTableContainerProps: {
      sx: { backgroundColor: "#fff", maxHeight: '400px', overflow: 'auto' },
      className: "table-position__new",
    },
    muiTableFooterProps: {
      sx: { backgroundColor: "#fff" },
      className: "table-footer-wrapper__new",
    },
    muiBottomToolbarProps: {
      sx: { backgroundColor: "#fff", padding: "8px" },
      className: "bottom-toolbar-wrapper__new",
    },
    state: { isLoading: isLoadingSecond, showProgressBars: isLoadingSecond },
    renderTopToolbarCustomActions: () => (
      <Box sx={{ marginLeft: "auto", display: "flex", alignItems: "center" }}>
        <Tooltip title="Export">
          <IconButton
            color="primary"
            onClick={() =>
              handleExportThirdTable(thirdTableColumns, thirdTableData)
            }
          >
            <GetAppIcon />
          </IconButton>
        </Tooltip>
      </Box>
    ),
  });

  const forthTable = useMaterialReactTable({
    columns: fourthTableColumns,
    data: forthTableData,
    enableDensityToggle: false,
    createDisplayMode: "row",
    editDisplayMode: "row",
    enableEditing: false,
    enableColumnOrdering: true,
    enableRowOrdering: false,
    getRowId: (row) => row.id || row.exec_id || Math.random().toString(),
    enableColumnFilterModes: false,
    initialState: { showColumnFilters: false },
    enableStickyFooter: false,
    enableColumnPinning: true,
    enablePagination: false,
    positionToolbarAlertBanner: "bottom",
    enableColumnResizing: true,
    columnResizeMode: "onEnd",
    defaultColumn: { minSize: 50, enableResizing: true },

    muiTableBodyRowProps: ({ row, table }) => {
      // Define color mapping for derivative values
      const derivativeColors: Record<string, string> = {
        swaps: "transparent", // Light green for swaps
        futures: " #EEEFE0", // Light blue for futures
        // Add more derivative types and colors as needed
        default: "transparent", // Fallback color
      };

      // Get the derivative value from the row
      const derivative = row.getValue(DERIVATIVE) as string;
      const backgroundColor =
        derivativeColors[derivative] || derivativeColors.default;

      return {
        onKeyDown: (event: React.KeyboardEvent<HTMLTableRowElement>) => {
          if (event.key === "Enter") {
            event.preventDefault();
            const editingRow = table.getState().editingRow;
            if (editingRow) {
              const saveHandler = table.options.onEditingRowSave;
              if (saveHandler) {
                const newedit = {
                  ...editingRow.original,
                  ...editingRow._valuesCache,
                };
                saveHandler({
                  exitEditingMode: () => table.setEditingRow(null),
                  row: editingRow,
                  table,
                  values: newedit,
                });
              }
            }
          }
        },
        sx: {
          backgroundColor, // Apply dynamic background color
          "&:hover": {
            backgroundColor: `color-mix(in srgb, ${backgroundColor}, #000000 10%)`, // Slightly darker on hover
          },
          ...(table.getState().editingRow?.id === row.id && {
            backgroundColor: "rgba(0, 128, 0, 0.1)", // Override for editing row
            transition: "background-color 0.3s ease",
          }),
        },
      };
    },
    muiTableHeadCellProps: {
      sx: {
        border: "1px solid #e0e0e087",
        fontStyle: "italic",
        fontWeight: "normal",
      },
    },
    muiTableBodyCellProps: { sx: { border: "1px solid #ebe9e98f" } },
    muiTablePaperProps: {
      elevation: 0,
      sx: { borderRadius: "0", border: "0" },
    },
    muiTopToolbarProps: {
      sx: {
        backgroundColor: "#fff",
        padding: "8px",
        "& .MuiBox-root.css-wsew38": {
          backgroundColor: "#fff",
          display: "flex",
          alignItems: "center",
          gap: "8px",
        },
      },
      className: "top-toolbar-wrapper__new",
    },
    muiTableContainerProps: {
      sx: { backgroundColor: "#fff" },
      className: "table-position__new",
    },
    muiTableFooterProps: {
      sx: { backgroundColor: "#fff" },
      className: "table-footer-wrapper__new",
    },
    muiBottomToolbarProps: {
      sx: { backgroundColor: "#fff", padding: "8px" },
      className: "bottom-toolbar-wrapper__new",
    },
    state: { isLoading: isLoadingSecond, showProgressBars: isLoadingSecond },
  });
  return (
    <div className="page-body">
      <Container fluid>
        <Row>
          <div>
            <div className="table-ad">
              <Accordion defaultActiveKey="0" className="table-ad__addInputs">
                <Accordion.Item eventKey="0">
                  <Accordion.Header className="accordion_button">
                    Paper Position
                  </Accordion.Header>
                  <Accordion.Body style={{ paddingTop: 0, paddingBottom: 0 }}>
                    <div
                      className="table-ad__wrapper tablePaperPosition"
                      style={{ marginBottom: 0, paddingBottom: 0 }}
                    >
                      <Box
                        sx={{ borderBottom: 1, borderColor: "divider", mb: 2 }}
                      >
                        <Tabs
                          value={activeTab}
                          onChange={(e, newValue) => setActiveTab(newValue)}
                          aria-label="page tabs"
                          textColor="primary"
                          indicatorColor="primary"
                        >
                          <Tab
                            label="Company Position"
                            onClick={handleClearAllFilters}
                            sx={{
                              textTransform: "none",
                              fontWeight: "0.75rem",
                            }}
                          />
                          <Tab
                            label="Customer Position"
                            onClick={handleClearAllFilters}
                            sx={{
                              textTransform: "none",
                              fontWeight: "0.75rem",
                            }}
                          />
                        </Tabs>
                      </Box>
                      <Box
                        sx={{
                          top: 0,
                          zIndex: 100,
                          display: "flex",
                          flexWrap: "wrap",
                          alignItems: "center",
                          gap: 1,
                          mt: 1,
                          p: 1,
                          backgroundColor: "#ffffff",
                          border: "1px solid #d1d5db",
                          borderRadius: "6px",
                          boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
                        }}
                      >
                        {/* UNIT */}
                        <Box sx={FILTER_WIDTH}>
                          <FilterAutocomplete
                            label="Unit"
                            options={unitOptions}
                            value={selectedUnit}
                            onChange={setSelectedUnit}
                            placeholder="Select Unit"
                          />
                        </Box>


                        {/* CUSTOMER (TAB 1) */}
                        {activeTab === 1 && (
                          <Box sx={FILTER_WIDTH}>
                            <FilterAutocomplete
                              label="Customer"
                              required
                              options={custBookOptions}
                              value={tempSelectedCustBook}
                              onChange={(value) => {
                                handleTempCustBookChange(value);
                                if (value) setCustomerError(false);
                              }}
                              error={customerError}
                              helperText={customerError ? "Customer is required" : ""}
                            />
                          </Box>
                        )}

                        <Button
                          variant="outlined"
                          size="small"
                          onClick={() => setShowFilter((prev) => !prev)}
                          sx={{
                            height: "32px",
                            fontSize: "0.75rem",
                            textTransform: "none",
                            borderColor: "#9e9e9e",
                            color: "#424242",
                          }}
                        >
                          {showFilter ? "Hide Filters" : "More Filters"}
                        </Button>
                        {showFilter && (
                          <>
                            {/* TRADE TYPE */}
                            {activeTab === 0 && (
                              <Box sx={FILTER_WIDTH}>
                                <FilterField
                                  label="Trade Type"
                                  field="tradeType"
                                  options={tradeTypeOptions}
                                  value={tempSelectedTradeType}
                                  onChange={handleTempTradeTypeChange}
                                />
                              </Box>
                            )}

                            {activeTab === 1 && (
                              <Box sx={FILTER_WIDTH}>
                                <FilterField
                                  label="Customer Account"
                                  field={ACCOUNT}
                                  options={customerAccountOptions}
                                  value={tempSelectedCustomerAccount}
                                  onChange={handleTempCustomerAccountChange}
                                />
                              </Box>
                            )}

                            {/* CLEARER */}
                            <Box sx={FILTER_WIDTH}>
                              <FilterAutocomplete
                                label="Clearer"
                                options={clearerOptions}
                                value={tempSelectedClearer}
                                onChange={handleTempClearerChange}
                              />
                            </Box>

                            {/* CLEARING ACCOUNT */}
                            <Box sx={FILTER_WIDTH}>
                              <FilterField
                                label="Clearing Account"
                                field={CLEARING_ACCOUNT}
                                options={clearingAccountOptions}
                                value={tempSelectedClearingAccount}
                                onChange={handleTempClearingAccountChange}
                              />
                            </Box>
                            {/* BOOK (TAB 0) */}
                            {activeTab === 0 && (
                              <Box sx={FILTER_WIDTH}>
                                <FilterAutocomplete
                                  label="Book"
                                  options={bookOptions}
                                  value={tempSelectedBook}
                                  onChange={handleTempBookChange}
                                />
                              </Box>
                            )}
                            {/* STRATEGY */}
                            <Box sx={FILTER_WIDTH}>
                              <FilterAutocomplete
                                label="Strategy"
                                options={strategyOptions}
                                value={tempSelectedStrategy}
                                onChange={handleTempStrategyChange}
                              />
                            </Box>
                            {/* TRADE DATE */}
                            <Box sx={FILTER_WIDTH}>
                              <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DatePicker
                                  label="Trade Date"
                                  value={tempSelectedDate ? dayjs(tempSelectedDate) : null}
                                  onChange={(date) =>
                                    handleTempDateChange(date ? date.toDate() : null)
                                  }
                                  format="DD-MM-YYYY"
                                  slotProps={{
                                    actionBar: {
                                      actions: ['clear'],
                                      sx: {
                                        padding: '0px',
                                        margin: '0px',
                                        '& button': {
                                          fontSize: '0.65rem',
                                          padding: '2px 4px',
                                          minWidth: '35px',
                                        },
                                      },
                                    },
                                    popper: {
                                      sx: {
                                        '& .MuiDateCalendar-root': {
                                          width: '240px',
                                          transform: 'scale(0.9)',
                                          transformOrigin: 'top center',
                                          margin: '0px',
                                        },
                                        '& .MuiPickersLayout-root': {
                                          width: '240px',
                                          padding: '2px',
                                          margin: '0px',
                                        },
                                        '& .MuiDayCalendar-header': {
                                          padding: '2px 0',
                                        },
                                        '& .MuiPickersMonth-root': {
                                          width: '100%',
                                        },
                                      },
                                    },
                                    layout: {
                                      sx: {
                                        padding: '2px',
                                        margin: '0px',
                                        width: '240px',
                                        '& .MuiDayCalendar-weekContainer': {
                                          gap: '2px',
                                        },
                                      },
                                    },
                                    textField: {
                                      size: "small",
                                      fullWidth: true,
                                      InputLabelProps: {
                                        sx: {
                                          fontSize: "0.75rem",
                                        },
                                      },
                                      sx: {
                                        "& .MuiInputBase-root": {
                                          height: 32,
                                          fontSize: "0.75rem",
                                        },
                                        "& .MuiOutlinedInput-input": {
                                          padding: "6px 8px",
                                          fontSize: "0.75rem",
                                        },
                                        "& .MuiSvgIcon-root": {
                                          fontSize: "1rem",
                                        },
                                      },
                                    },
                                  }}
                                />
                              </LocalizationProvider>
                            </Box>
                          </>
                        )}

                        {/* ACTION BUTTONS */}
                        <Box
                          sx={{
                            display: "flex",
                            gap: 1,
                            alignItems: "center",
                          }}
                        >
                          <ActionButton
                            label="Apply"
                            onClick={handleApplyFilters}
                            backgroundColor="#00bcd4"
                            disabled={isApplyDisabled}
                          />
                          <ActionButton
                            label="Clear All"
                            onClick={handleClearAllFilters}
                            backgroundColor="#f44336"
                            disabled={isClearAllDisabled}
                          />
                        </Box>
                      </Box>
                      <div
                        className="table-ad__wrapperCard"
                        style={{
                          display: "inline-block",
                          width: tableData.length === 0 ? "100%" : "auto",
                          maxWidth: "100%",
                          marginBottom: 0,
                          paddingBottom: 0,
                        }}
                      >
                        {isLoading ? (
                          <Box
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                            height="200px"
                          >
                            <CircularProgress />
                          </Box>
                        ) : (
                          <MaterialReactTable
                            key={activeTab}
                            table={firstTable}
                          />
                        )}
                      </div>
                    </div>
                    {showSecondTable && (
                      <div className="table-ad__wrapper tablePaperPosition">
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "flex-start", // everything left-aligned
                            alignItems: "center",
                            marginBottom: 0,
                            marginTop: -2,
                            gap: 1, // space between h4 and icon
                          }}
                        >
                          <h4 style={{ margin: 0 }}>Transactions Summary</h4>

                          <IconButton
                            onClick={() => setShowSecondTable(false)}
                            size="small"
                            sx={{
                              padding: 0.5,
                              color: "#555", // subtle color
                              "&:hover": {
                                backgroundColor: "transparent",
                                color: "#d32f2f",
                              },
                            }}
                          >
                            <CloseIcon fontSize="small" />
                          </IconButton>
                        </Box>

                        <div
                          className="table-ad__wrapperCard"
                          style={{
                            display: "inline-block",
                            width: tableData.length === 0 ? "100%" : "auto",
                            maxWidth: "100%",
                          }}
                        >
                          {isLoadingSecond ? (
                            <Box
                              display="flex"
                              justifyContent="center"
                              alignItems="center"
                              height="200px"
                            >
                              <CircularProgress />
                            </Box>
                          ) : (
                            <MaterialReactTable table={secondTable} />
                          )}
                        </div>
                      </div>
                    )}

                    {showThirdTable && (
                      <div className="table-ad__wrapper tablePaperPosition">
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "flex-start", // everything left-aligned
                            alignItems: "center",
                            marginBottom: 0,
                            marginTop: -4,
                            gap: 1, // space between h4 and icon
                          }}
                        >
                          <h4 style={{ margin: 0 }}>Deals</h4>

                          <IconButton
                            onClick={() => setShowThirdTable(false)}
                            size="small"
                            sx={{
                              padding: 0.5,
                              color: "#555", // subtle color
                              "&:hover": {
                                backgroundColor: "transparent",
                                color: "#d32f2f",
                              },
                            }}
                          >
                            <CloseIcon fontSize="small" />
                          </IconButton>
                        </Box>
                        <div
                          className="table-ad__wrapperCard"
                          style={{
                            display: "inline-block",
                            width: tableData.length === 0 ? "100%" : "auto",
                            maxWidth: "100%",
                          }}
                        >
                          {isLoadingSecond ? (
                            <Box
                              display="flex"
                              justifyContent="center"
                              alignItems="center"
                              height="200px"
                            >
                              <CircularProgress />
                            </Box>
                          ) : (
                            <MaterialReactTable table={thirdTable} />
                          )}
                        </div>
                      </div>
                    )}

                    {showFourthTable && (
                      <div className="table-ad__wrapper tablePaperPosition">
                        {" "}
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "flex-start", // everything left-aligned
                            alignItems: "center",
                            marginBottom: 0,
                            marginTop: -3,
                            gap: 1, // space between h4 and icon
                          }}
                        >
                          <h4 style={{ margin: 0 }}>Grouping Summary</h4>

                          <IconButton
                            onClick={() => setFourthTable(false)}
                            size="small"
                            sx={{
                              padding: 0.5,
                              color: "#555", // subtle color
                              "&:hover": {
                                backgroundColor: "transparent",
                                color: "#d32f2f",
                              },
                            }}
                          >
                            <CloseIcon fontSize="small" />
                          </IconButton>
                        </Box>
                        <div
                          className="table-ad__wrapperCard"
                          style={{
                            display: "inline-block",
                            width: tableData.length === 0 ? "100%" : "auto",
                            maxWidth: "100%",
                          }}
                        >
                          {loading ? (
                            <Box
                              display="flex"
                              justifyContent="center"
                              alignItems="center"
                              height="200px"
                            >
                              <CircularProgress />
                            </Box>
                          ) : (
                            <MaterialReactTable table={forthTable} />
                          )}
                        </div>
                      </div>
                    )}
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            </div>
          </div>
        </Row>
      </Container>
    </div>
  );
};

// App component with React Query setup
const ReactQueryDevtoolsProduction = lazy(() =>
  import("@tanstack/react-query-devtools/build/modern/production.js").then(
    (d) => ({
      default: d.ReactQueryDevtools,
    })
  )
);

const queryClient = new QueryClient();

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <Example />
      {/* <Suspense fallback={null}>
        <ReactQueryDevtoolsProduction />
      </Suspense> */}
    </QueryClientProvider>
  );
}
